// The Stars Above — Star Map Engine
// Requires: d3 v3, d3.geo.projection, celestial.min.js (loaded via liquid)

(function() {
  'use strict';

  // ─────────────────────────────────────────────────────────────────────────
  // Constants & State
  // ─────────────────────────────────────────────────────────────────────────

  var DATA_PATH = 'https://kgoyal000.github.io/StarmapWithLocation/data/';
  var MOBILE_BREAKPOINT = 768;
  // Mobile preview width cap. Raised from 260 so the poster fills about 75% of a
  // typical phone screen (closer to The Night Sky). Every use is min(available, cap),
  // so small phones still fit.
  var MOBILE_POSTER_MAX_WIDTH = 320;

  var celestialInitialised = false;

  // Desktop size-change animation. One easing + duration shared by every moving part
  // (poster box, map wrapper, map canvas) so they glide together instead of the box
  // animating while the contents snap. Only a real size (ratio) change animates.
  var SIZE_DUR  = '0.5s';
  var SIZE_EASE = 'cubic-bezier(0.33, 0.0, 0.15, 1)';
  var lastRenderedRatio = null;

  var state = {
    lat: 51.5,
    lon: -0.12,
    locationName: 'London, United Kingdom',
    coordinates: '51.50° N, 0.12° W',
    size: '12" x 16"',
    format: 'Poster',
    frameColour: 'Black',
    printWidth: 3638,
    printHeight: 4819,
    gelatoUid: 'flat_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver',
    date: new Date(),
    shape: 'circle',
    bgColor: '#0a0a0a',
    starColor: '#ffffff',
    showBorder: true,
    name: '',
    message: '',
    font: "'Cormorant Garamond', serif",
    subheadingFont: "'Montserrat', sans-serif",
    constellations: true,
    milkyway: false,
    grid: true,
    constnames: false,
    variantId: null,
    locationSelected: false
  };

  // ─────────────────────────────────────────────────────────────────────────
  // Gelato product mappings
  // ─────────────────────────────────────────────────────────────────────────

  var GELATO_UIDS = {
    'Poster': {
      '12" x 16"': 'flat_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver',
      '18" x 24"': 'flat_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver',
      '24" x 32"': 'flat_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver'
    },
    'Wooden Framed Poster': {
      '12" x 16"': {
        'Black':       'framed_poster_mounted_300x400-mm-12x16-inch_black_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Chestnut':    'framed_poster_mounted_300x400-mm-12x16-inch_dark-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Natural Oak': 'framed_poster_mounted_300x400-mm-12x16-inch_natural-wood_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver',
        'White':       'framed_poster_mounted_300x400-mm-12x16-inch_white_wood_w12xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver'
      },
      '18" x 24"': {
        'Black':       'framed_poster_mounted_450x600-mm-18x24-inch_black_wood_w12xt22-mm_plexiglass_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Chestnut':    'framed_poster_mounted_450x600-mm-18x24-inch_dark-wood_wood_w12xt22-mm_plexiglass_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Natural Oak': 'framed_poster_mounted_450x600-mm-18x24-inch_natural-wood_wood_w12xt22-mm_plexiglass_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver',
        'White':       'framed_poster_mounted_450x600-mm-18x24-inch_white_wood_w12xt22-mm_plexiglass_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver'
      },
      '24" x 32"': {
        'Black':       'framed_poster_mounted_600x800-mm-24x32-inch_black_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Chestnut':    'framed_poster_mounted_600x800-mm-24x32-inch_dark-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver',
        'Natural Oak': 'framed_poster_mounted_600x800-mm-24x32-inch_natural-wood_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver',
        'White':       'framed_poster_mounted_600x800-mm-24x32-inch_white_wood_w12xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver'
      }
    },
    'Metal Framed Poster': {
      '12" x 16"': { 'Black': 'framed_poster_mounted_300x400-mm-12x16-inch_black_aluminum_w10xt22-mm_plexiglass_300x400-mm-12x16-inch_200-gsm-80lb-uncoated_4-0_ver' },
      '18" x 24"': { 'Black': 'framed_poster_mounted_450x600-mm-18x24-inch_black_aluminum_w10xt22-mm_plexiglass_450x600-mm-18x24-inch_200-gsm-80lb-uncoated_4-0_ver' },
      '24" x 32"': { 'Black': 'framed_poster_mounted_600x800-mm-24x32-inch_black_aluminum_w10xt22-mm_plexiglass_600x800-mm-24x32-inch_200-gsm-80lb-uncoated_4-0_ver' }
    },
    'Canvas': {
      '12" x 16"': 'canvas_300x400-mm-12x16-inch_canvas_wood-fsc-slim_4-0_ver',
      '18" x 24"': 'canvas_450x600-mm-18x24-inch_canvas_wood-fsc-slim_4-0_ver',
      '24" x 32"': 'canvas_600x800-mm-24x32-inch_canvas_wood-fsc-slim_4-0_ver'
    },
    'Wooden Framed Canvas': {
      '12" x 16"': {
        'Black':       'framed_canvas_geo_simplified_300x400-mm-12x16-inch_black_352x452-mm-14x18-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Chestnut':    'framed_canvas_geo_simplified_300x400-mm-12x16-inch_dark-wood_352x452-mm-14x18-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Natural Oak': 'framed_canvas_geo_simplified_300x400-mm-12x16-inch_natural-wood_352x452-mm-14x18-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0'
      },
      '18" x 24"': {
        'Black':       'framed_canvas_geo_simplified_450x600-mm-18x24-inch_black_502x652-mm-20x26-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Chestnut':    'framed_canvas_geo_simplified_450x600-mm-18x24-inch_dark-wood_502x652-mm-20x26-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Natural Oak': 'framed_canvas_geo_simplified_450x600-mm-18x24-inch_natural-wood_502x652-mm-20x26-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0'
      },
      '24" x 32"': {
        'Black':       'framed_canvas_geo_simplified_600x800-mm-24x32-inch_black_652x852-mm-26x34-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Chestnut':    'framed_canvas_geo_simplified_600x800-mm-24x32-inch_dark-wood_652x852-mm-26x34-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0',
        'Natural Oak': 'framed_canvas_geo_simplified_600x800-mm-24x32-inch_natural-wood_652x852-mm-26x34-inch_wood-fsc-slim_ver_wood_w14xt42-mm_canvas_4-0'
      }
    }
  };

  var SIZE_MAP = {
    '12" x 16"': { w: 3638, h: 4819, ratio: 1.325 },
    '18" x 24"': { w: 5410, h: 7182, ratio: 1.4 },
    '24" x 32"': { w: 7050, h: 9400, ratio: 1.5 }
  };

  var CANVAS_SIZE_MAP = {
    '12" x 16"': { w: 4701, h: 5882 },
    '18" x 24"': { w: 6473, h: 8245 },
    '24" x 32"': { w: 7050, h: 9400 }
  };

  var FRAME_COLOURS = {
    'Black':       '#1a1a1a',
    'White':       '#f5f5f5',
    'Natural Oak': '#b8924a',
    'Chestnut':    '#5c2e1a'
  };

  var MAP_WIDTHS = { '12" x 16"': '82%', '18" x 24"': '82%', '24" x 32"': '82%' };
  var DESKTOP_TEXT_TOPS = { '12" x 16"': '70%', '18" x 24"': '70%', '24" x 32"': '70%' };
  var MOBILE_TEXT_TOP = '72%';

  // ─────────────────────────────────────────────────────────────────────────
  // Utilities
  // ─────────────────────────────────────────────────────────────────────────

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function needsFrame(format) {
    return format === 'Wooden Framed Poster' || format === 'Metal Framed Poster' || format === 'Wooden Framed Canvas';
  }

  function isCanvasFormat(format) {
    return format === 'Canvas' || format === 'Wooden Framed Canvas';
  }

  function $(id) {
    return document.getElementById(id);
  }

  function formatCoords(lat, lon) {
    var latDir = lat >= 0 ? 'N' : 'S';
    var lonDir = lon >= 0 ? 'E' : 'W';
    return Math.abs(lat).toFixed(2) + '° ' + latDir + ', ' + Math.abs(lon).toFixed(2) + '° ' + lonDir;
  }

  function formatDate(date) {
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var d = date.getDate();
    var suffix = (d % 100 >= 11 && d % 100 <= 13) ? 'th' : d % 10 === 1 ? 'st' : d % 10 === 2 ? 'nd' : d % 10 === 3 ? 'rd' : 'th';
    return d + suffix + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
  }

  function formatTime(date) {
    var h = date.getHours();
    var m = date.getMinutes();
    var ampm = h >= 12 ? 'pm' : 'am';
    var displayHour = h % 12;
    if (displayHour === 0) displayHour = 12;
    return displayHour + ':' + (m < 10 ? '0' + m : m) + ' ' + ampm;
  }

  function getBrightness(hex) {
    var r = parseInt(hex.slice(1,3), 16);
    var g = parseInt(hex.slice(3,5), 16);
    var b = parseInt(hex.slice(5,7), 16);
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  function getGelatoUid() {
    var formatData = GELATO_UIDS[state.format];
    if (!formatData) return null;
    var sizeData = formatData[state.size];
    if (!sizeData) return null;
    if (typeof sizeData === 'string') return sizeData;
    return sizeData[state.frameColour] || null;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Auto-scale text to fit a given width (mobile only)
  // ─────────────────────────────────────────────────────────────────────────

  function fitTextToWidth(element, maxWidth, startSize, minSize) {
    if (!element || !element.textContent || !maxWidth) return;
    var size = startSize;
    element.style.fontSize = size + 'px';
    element.style.whiteSpace = 'nowrap';
    // Shrink until it fits or hits the floor
    while (element.scrollWidth > maxWidth && size > minSize) {
      size -= 0.5;
      element.style.fontSize = size + 'px';
    }
    // If still overflowing at the minimum, allow wrapping as last resort
    if (element.scrollWidth > maxWidth) {
      element.style.whiteSpace = 'normal';
    }
  }

  function applyMobileAutoScale() {
    if (!isMobile()) return;
    var mapWrapper = $('sm-map-wrapper');
    var nameEl = $('sm-poster-name');
    var msgEl = $('sm-poster-message');
    if (!mapWrapper) return;

    // Available width = map wrapper width minus small padding
    var maxWidth = mapWrapper.offsetWidth - 16;
    if (maxWidth <= 0) return;

    // Use the most-recently-set font size as the starting point
    if (nameEl) {
      var nameStart = parseFloat(nameEl.style.fontSize) || 20;
      fitTextToWidth(nameEl, maxWidth, nameStart, 10);
    }
    if (msgEl) {
      var msgStart = parseFloat(msgEl.style.fontSize) || 12;
      fitTextToWidth(msgEl, maxWidth, msgStart, 7);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Poster text updates
  // ─────────────────────────────────────────────────────────────────────────

  function updatePosterText() {
    var nameEl = $('sm-poster-name');
    var msgEl = $('sm-poster-message');
    var dateEl = $('sm-poster-date');
    var locEl = $('sm-poster-location');
    var coordEl = $('sm-poster-coords');

    if (nameEl) {
      nameEl.textContent = state.name || 'Your Heading';
      nameEl.style.opacity = state.name ? '1' : '0.75';
    }
    if (msgEl) {
      msgEl.textContent = state.message || '';
      msgEl.style.opacity = state.message ? '1' : '0.75';
    }
    if (dateEl) dateEl.textContent = formatDate(state.date);
    if (locEl) locEl.textContent = state.locationName;
    if (coordEl) coordEl.textContent = state.coordinates;

    // After text changes, re-fit on mobile
    applyMobileAutoScale();

    // The visible poster text is drawn by the SVG layer — redraw it so typed
    // heading/subheading (and date/coords/location) update live. No-ops in the
    // DOM-fallback path (refreshChrome guards on window.PosterSVG + the layer).
    refreshChrome();
  }

  function updateFrameColour() {
    var poster = $('sm-poster');
    if (!poster) return;
    var colour = needsFrame(state.format) ? (FRAME_COLOURS[state.frameColour] || '#1a1a1a') : '#1a1a1a';
    poster.style.border = '12px solid ' + colour;
  }

  function updatePosterTheme(mode) {
    var poster = $('sm-poster');
    if (poster) poster.setAttribute('data-theme', mode);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Layout & scaling (single source of truth)
  // ─────────────────────────────────────────────────────────────────────────

function posterRatio() {
    // Mobile preview locked to an 18x24 shape so the GUI doesn't jump on size change.
    if (isMobile()) { var d = SIZE_MAP['18" x 24"']; return d.h / d.w; }
    // Desktop: always render at 24x32 proportions regardless of selected size —
    // the poster stays visually stable, only format/frame changes are visible.
    var isC = isCanvasFormat(state.format);
    var lockedDims = (isC ? CANVAS_SIZE_MAP : SIZE_MAP)['24" x 32"'];
    return lockedDims.h / lockedDims.w;
  }

  function buildPosterSVG() {
    // noRing:true — the live celestial map draws its own ring in the editor,
    // so we suppress the SVG ring here to avoid two concentric circles.
    return PosterSVG.renderPosterSVG(state, { ratio: posterRatio(), border: state.showBorder, noRing: true });
  }

  // Light refresh: redraw ONLY the SVG chrome (text, bg, border) in place.
  function refreshChrome() {
    if (!window.PosterSVG) return;
    var layer = $('sm-poster-svg-layer');
    if (!layer) return;
    layer.innerHTML = buildPosterSVG();
    var e = layer.querySelector('svg');
    if (e) {
      // Match renderEditorPoster so an in-place refresh can't flip aspect handling
      // (which would shift the border a hair).
      e.setAttribute('preserveAspectRatio', 'none');
      e.style.width = '100%'; e.style.height = '100%'; e.style.display = 'block';
    }
  }

  function renderEditorPoster() {
    var preview = document.querySelector('.sm-preview');
    var poster = $('sm-poster');
    if (!preview || !poster || !window.PosterSVG) return;

    // Animate only on desktop, and only when the poster shape (ratio) actually
    // changes — i.e. a real size switch. Location / colour / text refreshes keep the
    // same ratio, so they paint instantly with no transition (no border wobble).
    var ratio = posterRatio();
    var ratioChanged = (lastRenderedRatio !== null) && (Math.abs(lastRenderedRatio - ratio) > 0.0005);
    var animate = !isMobile() && ratioChanged;
    var boxTrans = animate
      ? ('width ' + SIZE_DUR + ' ' + SIZE_EASE + ', height ' + SIZE_DUR + ' ' + SIZE_EASE +
         ', transform ' + SIZE_DUR + ' ' + SIZE_EASE + ', margin-bottom ' + SIZE_DUR + ' ' + SIZE_EASE)
      : 'none';
    var slotTrans = animate
      ? ('left ' + SIZE_DUR + ' ' + SIZE_EASE + ', top ' + SIZE_DUR + ' ' + SIZE_EASE +
         ', width ' + SIZE_DUR + ' ' + SIZE_EASE + ', height ' + SIZE_DUR + ' ' + SIZE_EASE)
      : 'none';

    var Wpx = isMobile() ? Math.min(preview.offsetWidth - 32, MOBILE_POSTER_MAX_WIDTH) : 600;
    var Hpx = Math.round(Wpx * ratio);
    poster.style.transition = boxTrans;
    poster.style.background = state.bgColor;   // keep the box bg matched to the SVG bg
    poster.style.width = Wpx + 'px';
    poster.style.height = Hpx + 'px';
    poster.style.transform = 'none';
    poster.style.marginBottom = '0';
    if (!isMobile()) {
      var fit = Math.min((preview.offsetWidth - 48) / Wpx, (preview.offsetHeight - 48) / Hpx, 1);
      poster.style.transform = 'scale(' + fit + ')';
      poster.style.transformOrigin = 'top center';
      poster.style.marginBottom = ((Hpx * fit) - Hpx) + 'px';
    }

    var oldText = document.querySelector('.sm-poster-text'); if (oldText) oldText.style.display = 'none';
    var oldBorder = $('sm-poster-border'); if (oldBorder) oldBorder.style.display = 'none';

    var layer = $('sm-poster-svg-layer');
    if (!layer) {
      layer = document.createElement('div');
      layer.id = 'sm-poster-svg-layer';
      layer.style.cssText = 'position:absolute;inset:0;z-index:1;pointer-events:none;';
      poster.insertBefore(layer, poster.firstChild);
    }
    layer.innerHTML = buildPosterSVG();
    var svgEl = layer.querySelector('svg');
    if (svgEl) {
      // preserveAspectRatio:none couples the SVG to the box, so as the box height
      // transitions the ring/text stretch WITH it (staying locked to the map) rather
      // than re-snapping. At rest the box ratio equals the viewBox ratio, so no
      // distortion remains once the transition settles.
      svgEl.setAttribute('preserveAspectRatio', 'none');
      svgEl.style.width = '100%'; svgEl.style.height = '100%'; svgEl.style.display = 'block';
    }

    var L = PosterSVG.computeLayout({ ratio: ratio });

    // Position the LIVE map wrapper into the slot circle — by % of the inner
    // box, so the poster's border can't offset it (fixes the rightward lean).
    var mapWrapper = $('sm-map-wrapper');
    if (mapWrapper) {
      mapWrapper.style.transition = slotTrans;
      mapWrapper.style.position = 'absolute';
      mapWrapper.style.margin = '0';
      mapWrapper.style.aspectRatio = 'auto';
      mapWrapper.style.left   = ((L.slot.cx - L.slot.r) / L.vbW * 100) + '%';
      mapWrapper.style.top    = ((L.slot.cy - L.slot.r) / L.vbH * 100) + '%';
      mapWrapper.style.width  = (L.slot.d / L.vbW * 100) + '%';
      mapWrapper.style.height = (L.slot.d / L.vbH * 100) + '%';
      mapWrapper.style.zIndex = '2';
    }

    // Scale the celestial canvas inside its (now geometry-sized) container.
    // 1.15 matches the engine's MAP_ZOOM so editor and print crop identically.
    var mapContainer = document.querySelector('.sm-map-container');
    var mapEl = $('sm-celestial-map');
    if (mapContainer && mapEl) {
      // Derive the map zoom from the engine (drawD / d = MAP_ZOOM) so the live map
      // fills the ring exactly the way the print does — one source for the crop.
      var zoom = L.slot.d ? (L.slot.drawD / L.slot.d) : 1.25;
      var ms = (mapContainer.offsetWidth / 1000) * zoom;
      mapEl.style.transition = animate ? ('transform ' + SIZE_DUR + ' ' + SIZE_EASE) : 'none';
      mapEl.style.transform = 'translate(-50%, -50%) scale(' + ms + ')';
    }

    lastRenderedRatio = ratio;
  }

  function updateMapScale() {
    if (window.PosterSVG) { return renderEditorPoster(); }
    var preview = document.querySelector('.sm-preview');
    var poster = $('sm-poster');
    if (!preview || !poster) return;

    var nameEl = $('sm-poster-name');
    var msgEl = $('sm-poster-message');
    var locEl = $('sm-poster-location');
    var coordEl = $('sm-poster-coords');
    var dateEl = $('sm-poster-date');
    var divEl = document.querySelector('.sm-poster-divider');
    var textEl = document.querySelector('.sm-poster-text');
    var mapWrapper = $('sm-map-wrapper');

    if (isMobile()) {
      // ── Mobile layout ──
      var availW = preview.offsetWidth - 32;
      var mobileW = Math.min(availW, MOBILE_POSTER_MAX_WIDTH);
      var mobileH = Math.round(mobileW * 1.3333);

      poster.style.width = mobileW + 'px';
      poster.style.height = mobileH + 'px';
      poster.style.transform = 'none';
      poster.style.marginBottom = '0';

      if (mapWrapper) mapWrapper.style.width = MAP_WIDTHS[state.size] || '78%';

      var fs = mobileW / 600;

      // Use the actual final mobile width as the reference so values stay deterministic
      var refMobileW = MOBILE_POSTER_MAX_WIDTH;
      var refFs = refMobileW / 600;
      var metaFontPx = Math.round(8 * refFs * 1.6);
      // Floor of 7px so the metadata never collapses to nothing
      if (metaFontPx < 7) metaFontPx = 7;

      if (nameEl) {
        nameEl.style.fontSize = Math.round(26 * fs * 1.6) + 'px';
        nameEl.style.lineHeight = '1.1';
      }
      if (msgEl) {
        msgEl.style.fontSize = Math.round(16 * fs * 1.6) + 'px';
        msgEl.style.lineHeight = '1.2';
      }
      if (locEl) locEl.style.fontSize = metaFontPx + 'px';
      if (coordEl) coordEl.style.fontSize = metaFontPx + 'px';
      if (dateEl) dateEl.style.fontSize = metaFontPx + 'px';
      if (divEl) divEl.style.width = Math.round(20 * fs) + 'px';
      if (textEl) {
        textEl.style.top = MOBILE_TEXT_TOP;
        textEl.style.bottom = 'auto';
      }

      // Apply auto-scale after sizes are set
      applyMobileAutoScale();
    } else {
      // ── Desktop layout ──
      // Always render at 24x32 proportions regardless of selected size — the poster stays visually stable,
      // only the frame/format changes visibly. Size is still tracked in state for pricing and fulfilment.
      var LOCKED_RATIO = SIZE_MAP['24" x 32"'].ratio;
      var newHeight = Math.round(600 * LOCKED_RATIO);
      var availWdesk = preview.offsetWidth - 48;
      var availH = preview.offsetHeight - 48;
      var scale = Math.min(availWdesk / 600, availH / newHeight, 1);

      poster.style.transition = 'transform 0.3s ease, background 0.3s ease';
      poster.style.width = '600px';
      poster.style.height = newHeight + 'px';
      poster.style.transform = 'scale(' + scale + ')';
      poster.style.transformOrigin = 'top center';
      poster.style.marginBottom = ((newHeight * scale) - newHeight) + 'px';

      // Fixed layout for the map wrapper and text (uses the 24x32 values)
      if (mapWrapper) mapWrapper.style.width = MAP_WIDTHS['24" x 32"'] || '84%';

      if (textEl) {
        textEl.style.top = DESKTOP_TEXT_TOPS['24" x 32"'] || '70%';
        textEl.style.bottom = 'auto';
      }

      // Desktop font sizes are constant (text doesn't scale with print size)
      var transStyle = 'font-size 0.4s ease';
      [nameEl, msgEl, locEl, coordEl, dateEl].forEach(function(el) {
        if (el) el.style.transition = transStyle;
      });

      if (nameEl) {
        nameEl.style.fontSize = '28px';
        nameEl.style.lineHeight = '';
        nameEl.style.whiteSpace = '';
      }
      if (msgEl) {
        msgEl.style.fontSize = '17px';
        msgEl.style.lineHeight = '';
        msgEl.style.whiteSpace = '';
      }
      if (locEl) locEl.style.fontSize = '10px';
      if (coordEl) coordEl.style.fontSize = '10px';
      if (dateEl) dateEl.style.fontSize = '10px';
      if (divEl) divEl.style.width = '32px';
    }

    // Scale the d3-celestial canvas to fit its container
    var mapContainer = document.querySelector('.sm-map-container');
    var mapEl = $('sm-celestial-map');
    if (mapContainer && mapEl) {
      var mapScale = (mapContainer.offsetWidth / 1000) * 1.15;
      mapEl.style.transform = 'translate(-50%, -50%) scale(' + mapScale + ')';
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Step 4 UI: size / format / frame colour interactions
  // ─────────────────────────────────────────────────────────────────────────

  function updateStep4UI() {
    var format = state.format;
    var size = state.size;
    var frameField = $('sm-frame-colour-field');

    // Show/hide frame colour field
    if (frameField) frameField.style.display = needsFrame(format) ? 'block' : 'none';

    // Filter frame colour swatches based on format
    var isMetalFrame = format === 'Metal Framed Poster';
    var isWoodenCanvas = format === 'Wooden Framed Canvas';
    document.querySelectorAll('.sm-swatch-option[data-frame-colour]').forEach(function(sw) {
      var colour = sw.dataset.frameColour;
      if (isMetalFrame && colour !== 'Black') {
        sw.style.display = 'none';
      } else if (isWoodenCanvas && colour === 'White') {
        sw.style.display = 'none';
      } else {
        sw.style.display = '';
      }
    });

    // Reset to Black if the current frame colour is invalid for the new format
    if ((isMetalFrame && state.frameColour !== 'Black') || (isWoodenCanvas && state.frameColour === 'White')) {
      state.frameColour = 'Black';
      document.querySelectorAll('.sm-swatch-option[data-frame-colour]').forEach(function(s) {
        s.classList.remove('sm-active');
      });
      var blackSwatch = document.querySelector('.sm-swatch-option[data-frame-colour="Black"]');
      if (blackSwatch) blackSwatch.classList.add('sm-active');
    }

    // Recompute layout for the new size
    updateMapScale();

    // Update Gelato UID, variant and price
    state.gelatoUid = getGelatoUid();
    updateVariantFromState();
    updatePriceDisplay();
    updateFrameColour();
  }

  function updateVariantFromState() {
    var variants = window.STARMAP_VARIANTS || [];
    var variant = variants.find(function(v) {
      return v.option1 === state.size && v.option2 === state.format;
    });
    if (variant) {
      state.variantId = variant.id;
      var variantInput = $('sm-variant-id');
      if (variantInput) variantInput.value = variant.id;
    }
  }

  function updatePriceDisplay() {
    var variants = window.STARMAP_VARIANTS || [];
    var variant = variants.find(function(v) {
      return v.option1 === state.size && v.option2 === state.format;
    });
    var priceEl = $('sm-price-display');
    if (variant && priceEl) {
      var format = window.STARMAP_MONEY_FORMAT || '£{{amount}}';
      var amount = (variant.price / 100).toFixed(2);
      priceEl.textContent = format
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(variant.price / 100))
        .replace('{{amount_with_comma_separator}}', amount);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Location autocomplete
  // ─────────────────────────────────────────────────────────────────────────

  function initLocationAutocomplete() {
    var input = $('sm-location');
    if (!input) return;

    var dropdown = document.createElement('div');
    dropdown.style.cssText = 'position:absolute;z-index:99999;background:#fff;border:1px solid #ddd;border-top:none;max-height:250px;overflow-y:auto;box-shadow:0 4px 12px rgba(0,0,0,0.15);border-radius:0 0 8px 8px;display:none;';
    document.body.appendChild(dropdown);

    function positionDropdown() {
      var rect = input.getBoundingClientRect();
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      dropdown.style.position = 'absolute';
      dropdown.style.top = (rect.bottom + scrollY) + 'px';
      dropdown.style.left = rect.left + 'px';
      dropdown.style.width = rect.width + 'px';
    }

    var debounceTimer;
    var currentReqId = 0;
    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      if (query.length < 3) {
        dropdown.style.display = 'none';
        return;
      }
      // Show searching state immediately for feedback while the geocoder responds.
      dropdown.innerHTML = '<div style="padding:12px 14px;font-size:13px;color:#8a8a8a;font-family:Montserrat,sans-serif;display:flex;align-items:center;gap:10px;"><div style="width:14px;height:14px;border:1.5px solid #e5e1db;border-top-color:#C9A96E;border-radius:50%;animation:sm-spin 0.8s linear infinite;"></div><span>Searching…</span></div>';
      positionDropdown();
      dropdown.style.display = 'block';
      debounceTimer = setTimeout(function() {
        var reqId = ++currentReqId;
        // Mapbox Geocoding v6 — fast, reliable, 100k free/month on standard tier.
        // Falls back to photon.komoot.io if the token isn't configured.
        var mapboxToken = (window.STARMAP_CONFIG || {}).mapbox_token;
        var geocodeUrl = mapboxToken
          ? 'https://api.mapbox.com/search/geocode/v6/forward?q=' + encodeURIComponent(query) + '&limit=5&language=en&access_token=' + encodeURIComponent(mapboxToken)
          : 'https://photon.komoot.io/api/?q=' + encodeURIComponent(query) + '&limit=5&lang=en';
        fetch(geocodeUrl)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (reqId !== currentReqId) return;
            dropdown.innerHTML = '';
            if (!data.features || !data.features.length) {
              dropdown.style.display = 'none';
              return;
            }
            data.features.forEach(function(feature) {
              var props = feature.properties || {};
              var coords = feature.geometry.coordinates;
              // Mapbox exposes place_formatted / full_address; photon uses name/city/country.
              var displayName;
              if (props.full_address || props.place_formatted) {
                displayName = props.full_address || props.place_formatted;
              } else {
                var parts = [props.name || ''];
                if (props.city && props.city !== props.name) parts.push(props.city);
                if (props.country && props.country !== props.name) parts.push(props.country);
                displayName = parts.join(', ');
              }
              var item = document.createElement('div');
              item.style.cssText = 'padding:10px 14px;cursor:pointer;font-size:14px;border-bottom:1px solid #f0f0f0;font-family:Montserrat,sans-serif;color:#0A1628;';
              item.textContent = displayName;
              item.addEventListener('mouseenter', function() { this.style.background = '#f5f0eb'; });
              item.addEventListener('mouseleave', function() { this.style.background = '#fff'; });
              item.addEventListener('mousedown', function(e) {
                e.preventDefault();
                input.value = displayName;
                state.lat = coords[1];
                state.lon = coords[0];
                state.locationName = displayName;
                state.locationSelected = true;
                state.coordinates = formatCoords(coords[1], coords[0]);
                dropdown.style.display = 'none';
                updatePosterText();
                if (window.Celestial && celestialInitialised) {
                  Celestial.location([coords[1], coords[0]]);
                }
                // Celestial re-rendering can shift layout — recalculate sizing after it settles
                setTimeout(updateMapScale, 100);
              });
              dropdown.appendChild(item);
            });
            positionDropdown();
            dropdown.style.display = 'block';
          })
          .catch(function() { dropdown.style.display = 'none'; });
      }, 300);
    });

    input.addEventListener('blur', function() {
      setTimeout(function() { dropdown.style.display = 'none'; }, 200);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') dropdown.style.display = 'none';
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Celestial map rendering
  // ─────────────────────────────────────────────────────────────────────────

  function getCelestialConfig() {
    return {
      width: 1000,
      projection: 'airy',
      transform: 'equatorial',
      center: null,
      geopos: [state.lat, state.lon],
      follow: 'zenith',
      orientationfixed: true,
      zoomlevel: null,
      zoomextend: 1,
      adaptable: true,
      interactive: false,
      form: false,
      location: false,
      controls: false,
      container: 'sm-celestial-map',
      datapath: DATA_PATH,
      stars: {
        show: true,
        limit: 6,
        colors: false,
        style: { fill: state.starColor, opacity: 1 },
        designation: false,
        propername: false,
        size: 9.5,
        exponent: -0.28
      },
      dsos: { show: false },
      constellations: {
        show: state.constellations,
        names: state.constnames,
        lines: state.constellations,
        lineStyle: { stroke: state.starColor, width: 0.7, opacity: 0.4 },
        bounds: false
      },
      mw: {
        show: state.milkyway,
        style: { fill: state.starColor, opacity: 0.15 }
      },
      lines: {
        graticule: {
          show: state.grid,
          stroke: state.starColor,
          width: 0.6,
          opacity: 0.5
        },
        equatorial: { show: false },
        ecliptic: { show: false },
        galactic: { show: false },
        supergalactic: { show: false }
      },
      background: {
        fill: state.bgColor,
        opacity: 1,
        stroke: state.starColor,
        width: 3
      },
      horizon: { show: false },
      daylight: { show: false }
    };
  }

  function renderMap() {
    var mapEl = $('sm-celestial-map');
    if (mapEl) {
      mapEl.style.width = '1000px';
      mapEl.style.height = '1000px';
    }
    if (!window.Celestial) return;

    try {
      Celestial.display(getCelestialConfig());
      celestialInitialised = true;
    } catch(e) {
      // If first display fails, try once more (Celestial can be finicky)
      try { Celestial.display(getCelestialConfig()); } catch(e2) {}
    }

    // This celestial fork ignores names:false and always paints the constellation
    // labels onto its canvas (and re-uploading the file reverts any source edit). So
    // suppress them at the canvas level, then redraw once to clear what display() drew.
    patchMapText();
    try { Celestial.apply(getCelestialConfig()); } catch(e) {}

    // display() always draws the sky for "now". Apply the chosen date straight away,
    // while the poster is still hidden, so the first sky the customer sees is theirs
    // (a product page link, a saved design, or a date picked before the map loaded).
    try {
      var tz = Celestial.timezone ? Celestial.timezone() : 0;
      Celestial.date(state.date, tz);
    } catch(e) {}

    setTimeout(updateMapScale, 800);
    setTimeout(function() {
      var loader = $('sm-map-loading');
      if (loader) loader.classList.add('sm-fade-out');
      var poster = $('sm-poster');
      if (poster) {
        poster.classList.remove('sm-poster-loading');
        poster.classList.add('sm-poster-ready');
      }
    }, 800);
  }

  // Suppress the fork's constellation-name text on the MAP canvas only (gated by the
  // toggle), by intercepting its text-drawing calls. Other canvases (print, snapshot)
  // are untouched. This survives celestial-file re-uploads that revert the source edit.
  function patchMapText() {
    document.querySelectorAll('#sm-celestial-map canvas').forEach(function(cv) {
      if (cv.__smTextPatched) return;
      var ctx;
      try { ctx = cv.getContext('2d'); } catch(e) { return; }
      if (!ctx) return;
      ['fillText', 'strokeText'].forEach(function(fn) {
        if (typeof ctx[fn] !== 'function') return;
        var orig = ctx[fn];
        ctx[fn] = function() {
          if (!state.constnames) return;   // labels off → skip the draw
          return orig.apply(this, arguments);
        };
      });
      cv.__smTextPatched = true;
    });
  }

  function recolourMap() {
    if (!window.Celestial || !celestialInitialised) return;
    patchMapText();   // ensure the current map canvas is patched before it redraws
    try {
      Celestial.apply(getCelestialConfig());
    } catch(e) {
      console.warn('Celestial.apply failed:', e);
    }
    refreshChrome();
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Print canvas generation (for Gelato upload)
  // ─────────────────────────────────────────────────────────────────────────

  // Measure the region of the live map canvas that's visible in the editor's circle,
  // and return it as a source rect. The print draws straight from that canvas — no
  // PNG encode/decode in between — so it's both full-resolution and fast.
  function getEditorMapCrop() {
    var mapContainer = document.querySelector('.sm-map-container');
    var sourceCanvas = document.querySelector('#sm-celestial-map canvas');
    if (!mapContainer || !sourceCanvas) return null;

    var cRect = mapContainer.getBoundingClientRect();
    var sRect = sourceCanvas.getBoundingClientRect();
    if (!cRect.width || !sRect.width || !sourceCanvas.width) return null;

    var scaleX = sourceCanvas.width  / sRect.width;
    var scaleY = sourceCanvas.height / sRect.height;

    return {
      cv: sourceCanvas,
      sx: (cRect.left - sRect.left) * scaleX,
      sy: (cRect.top  - sRect.top)  * scaleY,
      sw: cRect.width  * scaleX,
      sh: cRect.height * scaleY
    };
  }

  var WORKER_URL = 'https://starmap-worker.thestarsabove.workers.dev';
  var R2_PUBLIC_URL = 'https://pub-cb76d8ae32574abe97650946e8421f75.r2.dev';

  // Serialise the design state into JSON safe for the render page. Excludes
  // Date object (rehydrated on the other end from ISO), variantId and other
  // UI-only fields — just what drawPoster() reads. celestialUrl is added later
  // after we upload the PNG.
  function serialiseRenderState() {
    return {
      bgColor: state.bgColor,
      showBorder: state.showBorder,
      name: state.name,
      message: state.message,
      font: state.font,
      subheadingFont: state.subheadingFont,
      locationName: state.locationName,
      coordinates: state.coordinates,
      date: state.date && state.date.toISOString ? state.date.toISOString() : new Date(state.date).toISOString(),
      size: state.size,
      format: state.format,
      frameColour: state.frameColour
    };
  }

  // Fire-and-forget render. Two steps happen in the browser before we resolve:
  //   1. Capture the live celestial canvas as a PNG (already-cropped square).
  //   2. Upload that PNG to R2 via /upload (a temp file keyed 'celestial-...').
  // Once the PNG URL is in hand we fire the render request to the Worker and
  // resolve immediately with the predicted final URL. The server does the
  // heavy print-resolution compositing in the background.
  //
  // Steps 1+2 take ~1-2s on modern devices, longer on weak devices. Crucially
  // they scale with the celestial capture size (~500KB-1MB PNG) rather than
  // the print canvas size (~200MB for 24x32), so old devices no longer get
  // stuck the way they did with the client-side render.
  //
  // Safety net: if the server render fails silently, the cron's file-existence
  // check catches it before Gelato submission. If the initial celestial upload
  // or kick-off POST fails, we fall back to the client-side render.
  function uploadToWorker(orderId) {
    return new Promise(function (resolve, reject) {
      if (!window.PosterSVG) { reject(new Error('Poster engine not loaded')); return; }

      var predictedUrl = R2_PUBLIC_URL + '/starmaps/' + orderId + '.jpg';

      // Step 1: capture the celestial map from the editor.
      var celestialDataUrl;
      try {
        celestialDataUrl = captureEditorMapSquare();
      } catch (e) {
        console.warn('Celestial capture failed:', e && e.message, '— running client fallback');
        return uploadToWorkerClient(orderId).then(resolve, reject);
      }
      if (!celestialDataUrl) {
        console.warn('Celestial capture returned empty — running client fallback');
        return uploadToWorkerClient(orderId).then(resolve, reject);
      }

      // Step 2: upload the celestial PNG to R2. We use the existing /upload
      // endpoint with an orderId prefix of 'celestial-' so it lands at
      // starmaps/celestial-{orderId}.png (temp file, cleaned up by the cron's
      // 30-day sweep).
      var celestialOrderId = 'celestial-' + orderId;
      fetch(WORKER_URL + '/upload', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: celestialOrderId, png: celestialDataUrl })
      }).then(function (r) {
        if (!r.ok) throw new Error('Celestial upload HTTP ' + r.status);
        return r.json();
      }).then(function (data) {
        if (!data || !data.url) throw new Error('Celestial upload returned no URL');

        // Step 3: fire the render request. Don't await it — we resolve below
        // with the predicted URL as soon as the POST is in flight.
        var renderState = serialiseRenderState();
        renderState.celestialUrl = data.url;

        fetch(WORKER_URL + '/render-print/starmap', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ state: renderState, orderId: orderId })
        }).then(function (r2) {
          if (!r2.ok) {
            console.warn('Server render kick-off HTTP ' + r2.status + ' — running client fallback');
            uploadToWorkerClient(orderId);
          }
        }).catch(function (err) {
          console.warn('Server render kick-off failed:', err && err.message, '— running client fallback');
          uploadToWorkerClient(orderId);
        });

        // Resolve immediately so the customer can proceed to checkout.
        resolve(predictedUrl);
      }).catch(function (err) {
        console.warn('Celestial upload failed:', err && err.message, '— running client fallback');
        uploadToWorkerClient(orderId).then(resolve, reject);
      });
    });
  }

  // Pre-2026 client-side render — full print-resolution compositing in the
  // browser. Kept as fallback so a Cloudflare outage or a celestial-upload
  // failure never blocks an order. Remove once the server render has proven
  // itself over a couple of hundred orders.
  function uploadToWorkerClient(orderId) {
    var workerUrl = WORKER_URL;

    return new Promise(function(resolve, reject) {
      if (!window.PosterSVG) { reject(new Error('Poster engine not loaded')); return; }

      var isCanvas = isCanvasFormat(state.format);
      var sizeData = isCanvas ? CANVAS_SIZE_MAP[state.size] : SIZE_MAP[state.size];
      var W = sizeData ? sizeData.w : 4701;
      var H = sizeData ? sizeData.h : 6473;
      var ratio = H / W;

      // Canvas formats: keep the design inside the printable safe zone; the background
      // wraps out to the physical frame edge.
      var safeInset = null;
      var canvasSafeZones = {
        '12" x 16"': { w: 3554, h: 4709 },
        '18" x 24"': { w: 5320, h: 7094 },
        '24" x 32"': { w: 7085, h: 9450 }
      };
      if (isCanvas && canvasSafeZones[state.size]) {
        safeInset = PosterSVG.safeInsetFrac({ w: W, h: H }, canvasSafeZones[state.size]);
      }

      // Layout from the SAME engine the editor and enlarge modal use — single source of
      // truth, so the print can't drift from what the customer designed.
      // noSub: with no subheading the heading drops into its space (matches the engine).
      var L = PosterSVG.computeLayout({ ratio: ratio, safeInset: safeInset, noSub: !String(state.message || '').trim() });
      var scale = W / L.vbW;                 // viewBox units → print pixels
      function S(v){ return v * scale; }

      // The exact map crop the customer is looking at (sky disc + its ring), as a
      // source rect on the live canvas — drawn directly, no PNG round-trip.
      var crop = getEditorMapCrop();

      // Styling mirrored from render-poster-svg.js (keep in sync with the engine).
      var GRAD_TOP = 16, GRAD_BOT = -14;
      function shade(hex, d){
        hex = (hex || '#0a0a0a').replace('#', ''); if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        var r = parseInt(hex.substr(0,2),16), g = parseInt(hex.substr(2,2),16), b = parseInt(hex.substr(4,2),16);
        if (isNaN(r)) { r = 10; g = 10; b = 10; }
        function cl(v){ return Math.max(0, Math.min(255, Math.round(v))); }
        function hx(v){ return ('0' + cl(v).toString(16)).slice(-2); }
        return '#' + hx(r+d) + hx(g+d) + hx(b+d);
      }
      function isLightBg(hex){
        if (!hex) return false; hex = hex.replace('#',''); if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        var r = parseInt(hex.substr(0,2),16), g = parseInt(hex.substr(2,2),16), b = parseInt(hex.substr(4,2),16);
        if (isNaN(r)) return false; return (0.2126*r + 0.7152*g + 0.0722*b) > 150;
      }
      var light = isLightBg(state.bgColor);
      var col = {
        head: light ? 'rgba(15,25,45,0.95)' : 'rgba(255,255,255,0.95)',
        sub:  light ? 'rgba(15,25,45,0.82)' : 'rgba(255,255,255,0.82)',
        div:  light ? 'rgba(15,25,45,0.55)' : 'rgba(255,255,255,0.55)',
        cap:  light ? 'rgba(15,25,45,0.72)' : 'rgba(255,255,255,0.72)',
        bord: light ? 'rgba(15,25,45,0.45)' : 'rgba(255,255,255,0.55)'
      };
      var bg = state.bgColor || '#0a0a0a';

      function draw(mapSrc){
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');

        // Background — gradient (matches engine); flat if both deltas are 0
        if (GRAD_TOP === 0 && GRAD_BOT === 0) {
          ctx.fillStyle = bg;
        } else {
          var grad = ctx.createLinearGradient(0, 0, 0, H);
          grad.addColorStop(0, shade(bg, GRAD_TOP));
          grad.addColorStop(0.45, bg);
          grad.addColorStop(1, shade(bg, GRAD_BOT));
          ctx.fillStyle = grad;
        }
        ctx.fillRect(0, 0, W, H);

        // Map disc (already cropped, includes the ring) clipped to the slot circle
        if (mapSrc) {
          var s = L.slot;
          ctx.save();
          ctx.beginPath();
          ctx.arc(S(s.cx), S(s.cy), S(s.r), 0, Math.PI * 2);
          ctx.clip();
          // Draw the measured region of the live map canvas straight into the slot at
          // full native resolution — one drawImage, no encode/decode.
          ctx.drawImage(
            mapSrc.cv, mapSrc.sx, mapSrc.sy, mapSrc.sw, mapSrc.sh,
            S(s.cx - s.d/2), S(s.cy - s.d/2), S(s.d), S(s.d)
          );
          ctx.restore();
        }

        // Keyline border
        if (state.showBorder) {
          ctx.strokeStyle = col.bord;
          ctx.lineWidth = S(L.border.width);
          ctx.strokeRect(
            S(L.content.x + L.border.inset), S(L.content.y + L.border.inset),
            S(L.content.w - 2 * L.border.inset), S(L.content.h - 2 * L.border.inset)
          );
        }

        // Text — canvas fillText uses the browser's loaded fonts, so it matches the
        // editor exactly. Baseline is alphabetic to mirror SVG <text y=…>.
        var t = L.text;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';

        ctx.fillStyle = col.head;
        ctx.font = '300 ' + S(t.heading.size) + 'px ' + (state.font || "'Cormorant Garamond', serif");
        ctx.fillText(state.name || '', S(t.heading.x), S(t.heading.y));

        ctx.fillStyle = col.sub;
        ctx.font = 'italic 300 ' + S(t.sub.size) + 'px ' + (state.subheadingFont || "'Montserrat', sans-serif");
        ctx.fillText(state.message || '', S(t.sub.x), S(t.sub.y));

        ctx.strokeStyle = col.div;
        ctx.lineWidth = Math.max(1, S(1));
        ctx.beginPath();
        ctx.moveTo(S(t.divider.x1), S(t.divider.y));
        ctx.lineTo(S(t.divider.x2), S(t.divider.y));
        ctx.stroke();

        ctx.fillStyle = col.cap;
        ctx.font = '500 ' + S(t.caption.size) + 'px "Montserrat", sans-serif';
        var hadLS = ('letterSpacing' in ctx);
        if (hadLS) { try { ctx.letterSpacing = S(0.6) + 'px'; } catch (e) {} }
        var loc = (state.locationName || '').toUpperCase();
        var coord = state.coordinates || '';
        var dateStr = formatDate(state.date).toUpperCase();
        if (loc)     ctx.fillText(loc,     S(t.caption.x), S(t.caption.lines[0]));
        if (coord)   ctx.fillText(coord,   S(t.caption.x), S(t.caption.lines[1]));
        if (dateStr) ctx.fillText(dateStr, S(t.caption.x), S(t.caption.lines[2]));
        if (hadLS) { try { ctx.letterSpacing = '0px'; } catch (e) {} }

        // Export + upload — unchanged pipeline (R2 → 4h queue → cron → Gelato)
        canvas.toBlob(function(blob){
          var reader = new FileReader();
          reader.onload = function(){
            fetch(workerUrl + '/upload', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ orderId: orderId, png: reader.result })
            })
            .then(function(res){ return res.json(); })
            .then(function(data){ if (!data.url) throw new Error('Upload failed'); resolve(data.url); })
            .catch(reject);
          };
          reader.readAsDataURL(blob);
        }, 'image/jpeg', 0.95);
      }

      function proceed(mapSrc){
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function(){ draw(mapSrc); }, function(){ draw(mapSrc); });
        } else {
          draw(mapSrc);
        }
      }

      proceed(crop);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Preview snapshot (used in confirm modal and preview modal)
  // ─────────────────────────────────────────────────────────────────────────

  // Build the enlarge/confirm image straight from the SVG engine (single source of
  // truth). The live celestial canvas is captured once as a PNG and handed to the
  // engine as the circular slot image; the engine draws the ring, text, border and
  // frame around it — identical to the editor and to the eventual print. This is why
  // the modal can't drift: it's the same renderer the poster itself uses.
  // Capture EXACTLY what the editor is showing in the map circle, as a square PNG.
  // We measure the live canvas's on-screen box vs the container's box and copy the
  // visible source region — so the enlarge reproduces the editor's crop precisely,
  // rather than re-cropping with an independent zoom (which drifted).
  function captureEditorMapSquare(withWatermark) {
    var mapContainer = document.querySelector('.sm-map-container');
    var sourceCanvas = document.querySelector('#sm-celestial-map canvas');
    if (!mapContainer || !sourceCanvas) return '';

    var cRect = mapContainer.getBoundingClientRect();   // visible circle box (on screen)
    var sRect = sourceCanvas.getBoundingClientRect();   // map canvas box (transformed, on screen)
    if (!cRect.width || !sRect.width || !sourceCanvas.width) return '';

    // Map on-screen pixels back to the canvas's native pixels
    var scaleX = sourceCanvas.width  / sRect.width;
    var scaleY = sourceCanvas.height / sRect.height;

    // Source region of the native canvas that is visible inside the container box
    var sx = (cRect.left - sRect.left) * scaleX;
    var sy = (cRect.top  - sRect.top)  * scaleY;
    var sw = cRect.width  * scaleX;
    var sh = cRect.height * scaleY;

    // Capture at the source canvas's NATIVE resolution for the visible region, not a
    // fixed 1000px. Celestial draws at 1000 x devicePixelRatio, so on retina there's
    // real detail here that a 1000px capture would discard — this keeps it, and never
    // upscales beyond what actually exists (so it costs nothing and invents nothing).
    var OUT = Math.max(1000, Math.min(Math.round(sw), 3000));
    var out = document.createElement('canvas');
    out.width = OUT; out.height = OUT;
    var ctx = out.getContext('2d');
    // Leave transparent beyond the sky disc so the poster gradient shows through
    // and the fork's ring is the only boundary.
    try {
      ctx.drawImage(sourceCanvas, sx, sy, sw, sh, 0, 0, OUT, OUT);
      if (withWatermark && window.TSAStarWM) {
        var wmPoster = document.getElementById('sm-poster');
        window.TSAStarWM.stamp(ctx, OUT, !!(wmPoster && wmPoster.getAttribute('data-theme') === 'light'));
      }
      return out.toDataURL('image/png');
    } catch (e) {
      return '';
    }
  }

  function buildSvgSnapshot(reserveH) {
    if (!window.PosterSVG) return null;

    // Preferred: the exact editor crop. Fall back to the raw canvas if measuring fails.
    var slotHref = captureEditorMapSquare(true);
    var noZoom = !!slotHref;   // the measured square is already the final crop
    if (!slotHref) {
      var mapCanvas = document.querySelector('#sm-celestial-map canvas');
      try { slotHref = mapCanvas ? mapCanvas.toDataURL('image/png') : ''; }
      catch (e) { slotHref = ''; }
    }

    var svgMarkup = PosterSVG.renderPosterSVG(state, {
      ratio: posterRatio(),
      border: state.showBorder,
      slotImageHref: slotHref,
      slotNoZoom: noZoom,
      noRing: true
    });
    if (!svgMarkup) return null;

    // Fit the poster within the viewport while preserving its aspect ratio.
    var ratio = posterRatio();                       // height / width
    var pad = needsFrame(state.format) ? 16 : 0;
    // reserveH = vertical space the modal needs for its own chrome (title, summary,
    // buttons). Sizing the poster to what's actually free means it never overflows
    // into the buttons, and never needs CSS to squash it (which caused letterboxing).
    var reserve = (typeof reserveH === 'number') ? reserveH : 120;
    var maxW = Math.min(window.innerWidth - 48, 440) - pad * 2;
    var maxH = (window.innerHeight - reserve) - pad * 2;
    if (maxW < 40) maxW = 40;
    if (maxH < 40) maxH = 40;
    var drawW = maxW, drawH = maxW * ratio;
    if (drawH > maxH) { drawH = maxH; drawW = maxH / ratio; }

    var wrapper = document.createElement('div');
    wrapper.className = 'sm-preview-snapshot-wrap';
    var frameBg = needsFrame(state.format) ? (FRAME_COLOURS[state.frameColour] || '#1a1a1a') : 'transparent';
    var frameShadow = needsFrame(state.format) ? '0 20px 60px rgba(0,0,0,0.6)' : '0 10px 40px rgba(0,0,0,0.4)';
    wrapper.style.cssText = 'background:' + frameBg + ';padding:' + pad + 'px;border-radius:0;display:inline-block;line-height:0;box-shadow:' + frameShadow + ';';

    var holder = document.createElement('div');
    holder.className = 'sm-preview-snapshot';
    // Set with priority: theme CSS was stretching this box wider than the poster's
    // aspect ratio, which made the SVG letterbox and show the modal backdrop as
    // bands either side. Exact px + !important keeps the box on-ratio.
    holder.style.setProperty('width', Math.round(drawW) + 'px', 'important');
    holder.style.setProperty('height', Math.round(drawH) + 'px', 'important');
    holder.style.setProperty('background', 'transparent', 'important');
    holder.style.setProperty('line-height', '0', 'important');
    holder.innerHTML = svgMarkup;

    var svgEl = holder.querySelector('svg');
    if (svgEl) {
      svgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      svgEl.style.setProperty('display', 'block', 'important');
      svgEl.style.setProperty('width', Math.round(drawW) + 'px', 'important');
      svgEl.style.setProperty('height', Math.round(drawH) + 'px', 'important');
    }

    wrapper.appendChild(holder);
    return wrapper;
  }

  function generatePreviewSnapshot(reserveH) {
    // Preferred: render from the SVG engine so the modal matches the editor exactly.
    // Falls back to the DOM-measurement path below only if PosterSVG isn't present.
    var svgSnap = window.PosterSVG ? buildSvgSnapshot(reserveH) : null;
    if (svgSnap) return svgSnap;

    var poster = $('sm-poster');
    if (!poster) return null;

    // ── Measure the LIVE poster as the single source of truth ──
    // Every dimension below is READ from what's actually rendered, then scaled by K.
    // That's why the enlarge matches the live view exactly and can't drift.
    var posterRect = poster.getBoundingClientRect();
    if (!posterRect.width || !posterRect.height) return null;

    // desktop applies transform:scale() to the poster; neutralise it so font sizes
    // (which are in CSS px, pre-transform) land in the same space as the rects.
    var posterScale = posterRect.width / (poster.offsetWidth || posterRect.width);

    var OUTPUT_W = 1200;                         // ~native map res (1000px source) + crisp text
    var K = OUTPUT_W / posterRect.width;
    var W = Math.round(posterRect.width * K);
    var H = Math.round(posterRect.height * K);

    var snapCanvas = document.createElement('canvas');
    snapCanvas.width = W;
    snapCanvas.height = H;
    var ctx = snapCanvas.getContext('2d');

    function relRect(el) {
      var r = el.getBoundingClientRect();
      return {
        x:  (r.left - posterRect.left) * K,
        y:  (r.top  - posterRect.top)  * K,
        w:  r.width  * K,
        h:  r.height * K,
        cx: (r.left - posterRect.left + r.width  / 2) * K,
        cy: (r.top  - posterRect.top  + r.height / 2) * K
      };
    }

    // ── Background ──
    ctx.fillStyle = state.bgColor;
    ctx.fillRect(0, 0, W, H);

    // ── Map: copy the canvas at its ACTUAL on-screen box (transform + 1.15 zoom
    // are already baked into its rect), clipped to the container's circle. No magic
    // numbers — this reproduces exactly what the eye sees in the live poster. ──
    var mapContainer = document.querySelector('.sm-map-container');
    var sourceCanvas = document.querySelector('#sm-celestial-map canvas');
    if (mapContainer && sourceCanvas) {
      var c = relRect(mapContainer);
      var s = relRect(sourceCanvas);
      ctx.save();
      ctx.beginPath();
      ctx.arc(c.cx, c.cy, Math.min(c.w, c.h) / 2, 0, Math.PI * 2);
      ctx.clip();
      ctx.drawImage(sourceCanvas, s.x, s.y, s.w, s.h);
      ctx.restore();
    }

    // ── Border (if the live poster shows one) ──
    var borderEl = $('sm-poster-border');
    if (borderEl && getComputedStyle(borderEl).display !== 'none') {
      var b = relRect(borderEl);
      var bcs = getComputedStyle(borderEl);
      var bcol = bcs.borderTopColor;
      ctx.strokeStyle = (bcol && bcol !== 'rgba(0, 0, 0, 0)') ? bcol : 'rgba(255,255,255,0.6)';
      ctx.lineWidth = Math.max(1, (parseFloat(bcs.borderTopWidth) || 1) * posterScale * K);
      ctx.strokeRect(b.x, b.y, b.w, b.h);
    }

    // ── Text: each line drawn from its measured rect, font, colour & opacity ──
    function drawTextEl(el) {
      if (!el) return;
      var txt = (el.textContent || '').trim();
      if (!txt) return;
      var cs = getComputedStyle(el);
      // honour CSS text-transform (live uses uppercase on location/coords/date)
      var tt = cs.textTransform;
      if (tt === 'uppercase') txt = txt.toUpperCase();
      else if (tt === 'lowercase') txt = txt.toLowerCase();
      else if (tt === 'capitalize') txt = txt.replace(/\b\w/g, function(m){ return m.toUpperCase(); });
      var r = relRect(el);
      var fontPx = parseFloat(cs.fontSize) * posterScale * K;
      ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + fontPx + 'px ' + cs.fontFamily;
      ctx.fillStyle = cs.color;
      ctx.globalAlpha = parseFloat(cs.opacity || '1');
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(txt, r.cx, r.cy);
      ctx.globalAlpha = 1;
    }

    drawTextEl($('sm-poster-name'));
    drawTextEl($('sm-poster-message'));

    // ── Divider ──
    var divEl = document.querySelector('.sm-poster-divider');
    if (divEl && getComputedStyle(divEl).display !== 'none') {
      var d = relRect(divEl);
      var dcol = getComputedStyle(divEl).backgroundColor;
      if (!dcol || dcol === 'rgba(0, 0, 0, 0)') dcol = 'rgba(255,255,255,0.5)';
      ctx.fillStyle = dcol;
      ctx.fillRect(d.x, d.cy - Math.max(1, d.h / 2), d.w, Math.max(1, d.h || K));
    }

    drawTextEl($('sm-poster-location'));
    drawTextEl($('sm-poster-coords'));
    drawTextEl($('sm-poster-date'));

    // ── Watermark, centred on the map ──
    if (mapContainer) {
      var mw = relRect(mapContainer);
      ctx.save();
      ctx.translate(mw.cx, mw.cy);
      ctx.rotate(-Math.PI / 6);
      ctx.font = '600 ' + Math.round(0.10 * mw.w) + 'px Montserrat, sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.18)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('PREVIEW', 0, 0);
      ctx.restore();
    }

    // ── Wrapper + frame styling (unchanged) ──
    var wrapper = document.createElement('div');
    wrapper.className = 'sm-preview-snapshot-wrap';
    var framePadding = needsFrame(state.format) ? 16 : 0;
    var frameBg = needsFrame(state.format) ? (FRAME_COLOURS[state.frameColour] || '#1a1a1a') : 'transparent';
    var frameShadow = needsFrame(state.format) ? '0 20px 60px rgba(0,0,0,0.6)' : '0 10px 40px rgba(0,0,0,0.4)';
    wrapper.style.cssText = 'background:' + frameBg + ';padding:' + framePadding + 'px;border-radius:0;display:inline-block;box-shadow:' + frameShadow + ';';

    var img = document.createElement('img');
    img.src = snapCanvas.toDataURL('image/png');
    img.className = 'sm-preview-snapshot';
    img.style.cssText = 'display:block;max-width:100%;max-height:calc(100vh - 120px);width:auto;height:auto;';
    wrapper.appendChild(img);
    return wrapper;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Add to cart flow
  // ─────────────────────────────────────────────────────────────────────────

  function addToCart() {
    var btn = $('sm-add-btn');
    if (btn) btn.disabled = true;

    // No overlay theatre — the render is fire-and-forget on Cloudflare, so
    // there's no client work to wait through. Success shows the modal;
    // errors alert and re-enable the button.
    var cleanupOverlay = function() {};

    var orderId = 'sm-' + Date.now();
    uploadToWorker(orderId)
      .then(function(printUrl) {
        var variantId = state.variantId || ($('sm-variant-id') && $('sm-variant-id').value);
        if (!variantId) throw new Error('No variant selected');

        function pad(n) { return n < 10 ? '0' + n : '' + n; }
        var isoTimestamp = state.date.getFullYear() + '-' +
                           pad(state.date.getMonth() + 1) + '-' +
                           pad(state.date.getDate()) + 'T' +
                           pad(state.date.getHours()) + ':' +
                           pad(state.date.getMinutes());
        var preciseCoords = state.lat.toFixed(4) + ',' + state.lon.toFixed(4);

        var properties = {
          '_print_url': printUrl,
          '_gelato_uid': state.gelatoUid || '',
          '_order_id': orderId,
          '_iso_timestamp': isoTimestamp,
          '_precise_coords': preciseCoords,
          // Full design state for server-side print rendering. Underscore-prefixed keys
          // are hidden from the customer's cart but still visible in Shopify admin.
          '_bg_color': state.bgColor,
          '_star_color': state.starColor,
          '_heading_font': state.font,
          '_subheading_font': state.subheadingFont,
          '_show_border': state.showBorder ? '1' : '0',
          '_constellations': state.constellations ? '1' : '0',
          '_constnames': state.constnames ? '1' : '0',
          '_grid': state.grid ? '1' : '0',
          '_milkyway': state.milkyway ? '1' : '0',
          'Location': state.locationName,
          'Date': formatDate(state.date),
          'Time': formatTime(state.date),
          'Heading': state.name,
          'Subheading': state.message,
          'Size': state.size,
          'Format': state.format
        };
        if (needsFrame(state.format)) properties['Frame Color'] = state.frameColour;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
        });
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to add to cart');
        cleanupOverlay();

        // Second-item flow: if the customer is here from the modal offer
        // (flag set), they've now designed their second item — go straight to
        // cart and clear the flag. Otherwise this is a first item; show the
        // modal offering a second design at 25% off before routing to cart.
        var isSecondItem = false;
        try {
          isSecondItem = sessionStorage.getItem('tsa_second_item_flow') === '1';
          if (isSecondItem) sessionStorage.removeItem('tsa_second_item_flow');
        } catch (e) {}

        var cartRedirect = (window.STARMAP_CONFIG && window.STARMAP_CONFIG.cart_redirect) || '/cart';

        if (isSecondItem) {
          // Overlay stays visible ("Adding to your cart…") until the page
          // navigates — the browser's own transition then takes over.
          window.location.href = cartRedirect + '?updated=' + Date.now();
        } else {
          if (btn) btn.disabled = false;
          transitionPostBuyToOffer(cartRedirect);
        }
      })
      .catch(function(err) {
        console.error(err);
        cleanupOverlay();
        hidePostBuyOverlay();
        if (btn) btn.disabled = false;
        alert('Error: ' + err.message);
      });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Initial date/time population
  // ─────────────────────────────────────────────────────────────────────────

  function populateDateSelects() {
    var now = new Date();
    var dateEl = $('sm-date');
    var timeEl = $('sm-time');

    if (dateEl) {
      var yyyy = now.getFullYear();
      var mm = String(now.getMonth() + 1).padStart(2, '0');
      var dd = String(now.getDate()).padStart(2, '0');
      dateEl.value = yyyy + '-' + mm + '-' + dd;
      dateEl.min = '1900-01-01';
    }
    if (timeEl) {
      var hh = String(now.getHours()).padStart(2, '0');
      var mn = String(now.getMinutes()).padStart(2, '0');
      timeEl.value = hh + ':' + mn;
    }
  }

  function initShippingMessage() {
    var el = $('sm-shipping-msg');
    if (el) el.textContent = 'Complimentary Shipping Included';
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Input validation (Next button on step 1 and 2)
  // ─────────────────────────────────────────────────────────────────────────

  function flashFieldError(input, errorPlaceholder, originalPlaceholder) {
    input.style.borderColor = '#c0392b';
    input.style.boxShadow = '0 0 0 3px rgba(192,57,43,0.15)';
    input.placeholder = errorPlaceholder;
    setTimeout(function() {
      input.style.borderColor = '';
      input.style.boxShadow = '';
      input.placeholder = originalPlaceholder;
    }, 3000);
  }

  function wireStepValidation() {
    var step1NextBtn = $('sm-next-step1');
    if (step1NextBtn) {
      step1NextBtn.addEventListener('click', function(e) {
        var input = $('sm-location');
        if (!input || !input.value.trim() || !state.locationSelected) {
          e.stopImmediatePropagation();
          flashFieldError(input, 'Please enter a location first...', 'Search for a city or place...');
          input.focus();
        }
      }, true);
    }

    var step2NextBtn = $('sm-next-step2');
    if (step2NextBtn) {
      step2NextBtn.addEventListener('click', function(e) {
        // Only the heading is required. The subheading is optional, and the
        // poster simply leaves that line out when it's blank.
        var headingInput = $('sm-name-input');
        var headingEmpty = !headingInput || !headingInput.value.trim();
        if (headingEmpty) {
          e.stopImmediatePropagation();
          flashFieldError(headingInput, 'Please enter a heading...', 'Enter a heading or name...');
          headingInput.focus();
        }
      }, true);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Modal helpers (confirm + preview)
  // ─────────────────────────────────────────────────────────────────────────

  function wireModals() {
    // Final confirmation modal
    var confirmModal = $('sm-confirm-modal');
    var confirmPreview = $('sm-confirm-preview');
    var confirmSummary = $('sm-confirm-summary');
    var confirmEditBtn = $('sm-confirm-edit');
    var confirmBuyBtn = $('sm-confirm-buy');

    function showConfirmModal() {
      if (!confirmModal || !confirmPreview || !confirmSummary) return;
      // Leave room for the heading, the size/price summary and both buttons.
      var snapshot = generatePreviewSnapshot(360);
      if (!snapshot) return;

      confirmPreview.innerHTML = '';
      confirmPreview.appendChild(snapshot);

      // Hide live poster to reduce iOS memory pressure during pinch-zoom
      var livePoster = $('sm-poster');
      if (livePoster) livePoster.style.visibility = 'hidden';

      // Summary line
      var variants = window.STARMAP_VARIANTS || [];
      var variant = variants.find(function(v) {
        return v.option1 === state.size && v.option2 === state.format;
      });
      var priceStr = '';
      if (variant) {
        var fmt = window.STARMAP_MONEY_FORMAT || '£{{amount}}';
        var amount = (variant.price / 100).toFixed(2);
        priceStr = fmt
          .replace('{{amount}}', amount)
          .replace('{{amount_no_decimals}}', Math.round(variant.price / 100))
          .replace('{{amount_with_comma_separator}}', amount);
      }
      var formatLabel = needsFrame(state.format) ? (state.frameColour + ' ' + state.format) : state.format;
      confirmSummary.innerHTML = '<strong>' + state.size + '</strong> &nbsp;·&nbsp; <strong>' + formatLabel + '</strong>' +
        (priceStr ? '<br><strong style="font-size:14px;letter-spacing:0.08em;">' + priceStr + '</strong>' : '');

      // The SVG snapshot hugs the poster's exact aspect ratio, so any background on
      // the container shows as bands beside it. Keep the container invisible.
      confirmPreview.style.background = 'transparent';
      confirmPreview.style.boxShadow = 'none';

      confirmModal.classList.add('sm-visible');
      document.body.style.overflow = 'hidden';
    }

    function hideConfirmModal(skipRerender) {
      if (!confirmModal) return;
      confirmModal.classList.remove('sm-visible');
      document.body.style.overflow = '';
      var livePoster = $('sm-poster');
      if (livePoster) livePoster.style.visibility = '';
      setTimeout(function() {
        if (confirmPreview) confirmPreview.innerHTML = '';
        // Skipped when going to checkout: rebuilding the editor there re-scales the
        // map with a transition, which visibly jumps behind the cart overlay.
        if (!skipRerender) updateMapScale();
      }, 300);
    }

    var addBtn = $('sm-add-btn');
    if (addBtn) addBtn.addEventListener('click', showConfirmModal);
    if (confirmEditBtn) confirmEditBtn.addEventListener('click', function() { hideConfirmModal(); });
    if (confirmBuyBtn) {
      confirmBuyBtn.addEventListener('click', function() {
        // Show the post-buy overlay FIRST (covers the entire screen with the
        // same dark-blue palette as the confirm modal), then hide the confirm
        // modal beneath it. This prevents the editor flashing through during
        // the transition from confirm → offer / cart.
        showPostBuyOverlay();
        hideConfirmModal(true);   // no editor re-scale — we're leaving for checkout
        addToCart();
      });
    }
    if (confirmModal) {
      confirmModal.addEventListener('click', function(e) {
        if (e.target === confirmModal) hideConfirmModal();
      });
    }

    // Preview enlarge modal
    var previewBtn = $('sm-preview-btn');
    var previewModal = $('sm-preview-modal');
    var previewModalInner = $('sm-preview-modal-inner');
    var previewModalClose = $('sm-preview-modal-close');

    function openPreviewModal(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (!previewModal || !previewModalInner) return;
      var snapshot = generatePreviewSnapshot();
      if (!snapshot) return;
      previewModalInner.innerHTML = '';
      previewModalInner.appendChild(snapshot);
      var livePoster = $('sm-poster');
      if (livePoster) livePoster.style.visibility = 'hidden';
      previewModal.classList.add('sm-visible');
      document.body.style.overflow = 'hidden';
    }

    function closePreviewModal(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (!previewModal) return;
      previewModal.classList.remove('sm-visible');
      document.body.style.overflow = '';
      var livePoster = $('sm-poster');
      if (livePoster) livePoster.style.visibility = '';
      setTimeout(function() {
        if (previewModalInner) previewModalInner.innerHTML = '';
        updateMapScale();
      }, 300);
    }

    if (previewBtn) previewBtn.addEventListener('click', openPreviewModal);
    if (previewModalClose) previewModalClose.addEventListener('click', closePreviewModal);

    // On mobile, make the whole poster tappable to open the preview
    if (isMobile()) {
      var posterEl = $('sm-poster');
      if (posterEl) {
        posterEl.addEventListener('click', function(e) {
          // Don't fire if the user tapped the explicit button (it has its own handler)
          if (e.target.closest('#sm-preview-btn')) return;
          openPreviewModal(e);
        });
        posterEl.style.cursor = 'pointer';
      }
    }
    if (previewModal) {
      previewModal.addEventListener('click', function(e) {
        if (e.target === previewModal) closePreviewModal();
      });
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Wire up all the controls
  // ─────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────
  // Font choices only appear once there's text to style. Keeps step 2 tidy:
  // the heading font row shows once a heading is typed, the subheading font row
  // once a subheading is typed, and each hides again if its field is cleared.
  // The chosen font is kept either way.
  // ─────────────────────────────────────────────────────────────────────────

  function syncFontFields() {
    [['sm-name-input', 'sm-font-field-heading'], ['sm-message-input', 'sm-font-field-sub']].forEach(function (p) {
      var input = $(p[0]), field = $(p[1]);
      if (!input || !field) return;
      field.classList.toggle('is-collapsed', !input.value.trim());
    });
  }

  // Mark the font buttons that match the fonts in state (used after a saved
  // design is restored, so the highlighted button matches the poster).
  function syncFontButtons() {
    document.querySelectorAll('.sm-font-btn').forEach(function (b) {
      var target = b.dataset.fontTarget || 'message';
      var current = target === 'message' ? state.font : state.subheadingFont;
      b.classList.toggle('sm-active', b.dataset.font === current);
    });
  }

  function wireControls() {
    wireStepValidation();
    initLocationAutocomplete();

    // Reveal each font row once its field has text (and on load, in case the
    // browser restored typed values).
    ['sm-name-input', 'sm-message-input'].forEach(function (id) {
      var el = $(id);
      if (el) el.addEventListener('input', syncFontFields);
    });
    syncFontFields();

    // Mark text inputs / textareas as user-edited once typed in
    document.querySelectorAll('.sm-field input[type="text"], .sm-field textarea').forEach(function(el) {
      el.addEventListener('input', function() {
        if (el.value.trim()) el.classList.add('sm-user-edited');
        else el.classList.remove('sm-user-edited');
      });
    });

    // Date & time
    var dateEl = $('sm-date');
    var timeEl = $('sm-time');

function updateDate() {
      var dateVal = (dateEl && dateEl.value) || '';
      var timeVal = (timeEl && timeEl.value) || '00:00';
      if (!dateVal) return;
      var dp = dateVal.split('-');
      var tp = timeVal.split(':');
      state.date = new Date(
        parseInt(dp[0], 10) || 2024,
        (parseInt(dp[1], 10) || 1) - 1,
        parseInt(dp[2], 10) || 1,
        parseInt(tp[0], 10) || 0,
        parseInt(tp[1], 10) || 0
      );
      updatePosterText();
      if (window.Celestial && celestialInitialised) {
        var tz = Celestial.timezone ? Celestial.timezone() : 0;
        Celestial.date(state.date, tz);
      } else {
        renderMap();
      }
    }

    [dateEl, timeEl].forEach(function(el) {
      if (el) {
        el.addEventListener('change', function() {
          el.classList.add('sm-user-edited');
          updateDate();
        });
      }
    });

    // Safety net: on blur, if the year is nonsense, snap to a valid range
    if (dateEl) {
      dateEl.addEventListener('blur', function() {
        if (!dateEl.value) return;
        var dp = dateEl.value.split('-');
        var year = parseInt(dp[0], 10);
        var month = parseInt(dp[1], 10) || 1;
        var day = parseInt(dp[2], 10) || 1;
        var CURRENT_YEAR = new Date().getFullYear();
        var validYear = year;
        if (isNaN(year) || year < 1900) validYear = CURRENT_YEAR;
        if (year > 2100) validYear = CURRENT_YEAR;
        if (validYear !== year) {
          dateEl.value = validYear + '-' +
            (month < 10 ? '0' + month : month) + '-' +
            (day < 10 ? '0' + day : day);
          updateDate();
        }
      });
    }

    // Heading & subheading inputs
    var nameInput = $('sm-name-input');
    if (nameInput) {
      nameInput.addEventListener('input', function() {
        state.name = nameInput.value;
        updatePosterText();
      });
    }
    var msgInput = $('sm-message-input');
    if (msgInput) {
      msgInput.addEventListener('input', function() {
        state.message = msgInput.value;
        updatePosterText();
      });
    }

    // Character counters
    document.querySelectorAll('.sm-char-count').forEach(function(counter) {
      var input = $(counter.dataset.target);
      if (!input) return;
      var max = parseInt(input.getAttribute('maxlength'), 10) || 0;
      function updateCount() {
        var len = input.value.length;
        counter.textContent = len + ' / ' + max;
        counter.classList.remove('sm-near-limit', 'sm-at-limit');
        if (len >= max) counter.classList.add('sm-at-limit');
        else if (len >= max * 0.85) counter.classList.add('sm-near-limit');
      }
      input.addEventListener('input', updateCount);
      updateCount();
    });

    // Font selectors — heading affects only the heading, subheading affects only the subheading
    document.querySelectorAll('.sm-font-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.dataset.fontTarget || 'message';
        document.querySelectorAll('.sm-font-btn[data-font-target="' + target + '"]').forEach(function(b) {
          b.classList.remove('sm-active');
        });
        btn.classList.add('sm-active');
        var font = btn.dataset.font;

        if (target === 'message') {
          state.font = font;
          var nameEl = $('sm-poster-name');
          if (nameEl) nameEl.style.fontFamily = font;
        } else {
          state.subheadingFont = font;
          var msgEl = $('sm-poster-message');
          if (msgEl) msgEl.style.fontFamily = font;
        }
        // Font change can change rendered width — re-fit on mobile
        applyMobileAutoScale();
        refreshChrome();
      });
    });

    // Style buttons (border)
    document.querySelectorAll('.sm-style-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.sm-style-btn').forEach(function(b) { b.classList.remove('sm-active'); });
        btn.classList.add('sm-active');
        state.showBorder = (btn.dataset.style === 'border');
        refreshChrome();
      });
    });

    // Background colour swatches
    document.querySelectorAll('.sm-swatch-option[data-bg]').forEach(function(sw) {
      sw.addEventListener('click', function() {
        if (sw.dataset.bg === 'custom') {
          var wrap = $('sm-bg-picker-wrap');
          if (wrap) wrap.style.display = wrap.style.display === 'none' ? 'flex' : 'none';
          return;
        }
        document.querySelectorAll('.sm-swatch-option[data-bg]').forEach(function(s) { s.classList.remove('sm-active'); });
        sw.classList.add('sm-active');
        state.bgColor = sw.dataset.bg;
        var poster = $('sm-poster');
        if (poster) poster.style.background = state.bgColor;
        updatePosterTheme('dark');
        recolourMap();
      });
    });

    var bgCustomInput = $('sm-bg-custom');
    if (bgCustomInput) {
      bgCustomInput.addEventListener('change', function() {
        var val = this.value;
        document.querySelectorAll('.sm-swatch-option[data-bg]').forEach(function(s) { s.classList.remove('sm-active'); });
        var customSwatch = $('sm-bg-swatch-custom');
        if (customSwatch) customSwatch.classList.add('sm-active');
        state.bgColor = val;
        var poster = $('sm-poster');
        if (poster) poster.style.background = val;
        updatePosterTheme(getBrightness(val) > 160 ? 'light' : 'dark');
        recolourMap();
      });
    }

    // Star colour swatches
    document.querySelectorAll('.sm-swatch-option[data-star-color]').forEach(function(sw) {
      sw.addEventListener('click', function() {
        if (sw.dataset.starColor === 'custom') {
          var wrap = $('sm-star-picker-wrap');
          if (wrap) wrap.style.display = wrap.style.display === 'none' ? 'flex' : 'none';
          return;
        }
        document.querySelectorAll('.sm-swatch-option[data-star-color]').forEach(function(s) { s.classList.remove('sm-active'); });
        sw.classList.add('sm-active');
        state.starColor = sw.dataset.starColor;
        recolourMap();
      });
    });

    var starCustomInput = $('sm-star-custom');
    if (starCustomInput) {
      starCustomInput.addEventListener('change', function() {
        var val = this.value;
        document.querySelectorAll('.sm-swatch-option[data-star-color]').forEach(function(s) { s.classList.remove('sm-active'); });
        var customSwatch = $('sm-star-swatch-custom');
        if (customSwatch) customSwatch.classList.add('sm-active');
        state.starColor = val;
        recolourMap();
      });
    }

    // Sky toggles (constellations, milky way, grid, names, border)
    document.querySelectorAll('.sm-toggle-btn, .sm-sky-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        btn.classList.toggle('sm-active');
        var toggle = btn.dataset.toggle;
        var isOn = btn.classList.contains('sm-active');
        if (toggle === 'constellations') state.constellations = isOn;
        if (toggle === 'milkyway') state.milkyway = isOn;
        if (toggle === 'grid') state.grid = isOn;
        if (toggle === 'constnames') state.constnames = isOn;
        if (toggle === 'border') { state.showBorder = isOn; }
        recolourMap();
      });
    });

    // Step 4: size buttons
    document.querySelectorAll('.sm-size-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        document.querySelectorAll('.sm-size-btn').forEach(function(b) { b.classList.remove('sm-active'); });
        btn.classList.add('sm-active');
        state.size = btn.dataset.size;
        var sd = SIZE_MAP[state.size];
        if (sd) {
          state.printWidth = sd.w;
          state.printHeight = sd.h;
        }
        updateStep4UI();
      });
    });

    // Step 4: format buttons
    document.querySelectorAll('.sm-format-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.sm-format-btn').forEach(function(b) { b.classList.remove('sm-active'); });
        btn.classList.add('sm-active');
        state.format = btn.dataset.format;
        updateStep4UI();
      });
    });

    // Step 4: frame colour swatches
    document.querySelectorAll('.sm-swatch-option[data-frame-colour]').forEach(function(sw) {
      sw.addEventListener('click', function() {
        document.querySelectorAll('.sm-swatch-option[data-frame-colour]').forEach(function(s) { s.classList.remove('sm-active'); });
        sw.classList.add('sm-active');
        state.frameColour = sw.dataset.frameColour;
        state.gelatoUid = getGelatoUid();
        updateFrameColour();
      });
    });

    // Modals
    wireModals();

    // Status placeholder beneath cart button
    var cartSection = document.querySelector('.sm-cart-section');
    if (cartSection && !document.querySelector('.sm-status')) {
      var status = document.createElement('p');
      status.className = 'sm-status';
      status.style.cssText = 'text-align:center;font-size:12px;color:#C9A96E;margin-top:8px;min-height:20px;';
      cartSection.appendChild(status);
    }
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Mobile: pinch-zoom prevention & snap-back after input/keyboard
  // ─────────────────────────────────────────────────────────────────────────

  function initMobileHandlers() {
    if (!isMobile()) return;

    // Prevent pinch-zoom on the customiser (causes iOS memory crashes)
    // but allow it inside the preview/confirm modals (static images only)
    document.addEventListener('touchmove', function(e) {
      var previewModal = $('sm-preview-modal');
      var confirmModal = $('sm-confirm-modal');
      if (previewModal && previewModal.classList.contains('sm-visible')) return;
      if (confirmModal && confirmModal.classList.contains('sm-visible')) return;
      if (e.touches.length > 1) e.preventDefault();
    }, { passive: false });

    var lastTouchEnd = 0;
    document.addEventListener('touchend', function(e) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) e.preventDefault();
      lastTouchEnd = now;
    }, false);

    // Snap layout back after iOS expands the page for inputs/pickers
    var snapTimer = null;
    var inputActive = false;

    function snapBack() {
      if (inputActive) return;
      var controls = document.querySelector('.sm-controls');
      if (!controls) return;
      controls.style.height = '';
      controls.style.minHeight = '';
      var maxScroll = document.body.scrollHeight - window.innerHeight;
      if (window.scrollY > maxScroll) {
        window.scrollTo(0, Math.max(0, maxScroll));
      }
    }

    document.addEventListener('focusin', function(e) {
      if (e.target.closest('.sm-controls')) inputActive = true;
    });

    document.addEventListener('focusout', function(e) {
      if (e.target.closest('.sm-controls')) {
        inputActive = false;
        clearTimeout(snapTimer);
        snapTimer = setTimeout(snapBack, 500);
      }
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Init
  // ─────────────────────────────────────────────────────────────────────────

  // Make the sky toggle buttons reflect the current state defaults on load, so a
  // button hardcoded "on" in the Liquid can't disagree with the actual map (e.g.
  // Milky Way / constellation names now default off).
  function syncSkyToggles() {
    document.querySelectorAll('.sm-toggle-btn, .sm-sky-btn').forEach(function(btn) {
      var t = btn.dataset.toggle;
      var on;
      if (t === 'constellations') on = state.constellations;
      else if (t === 'milkyway') on = state.milkyway;
      else if (t === 'grid') on = state.grid;
      else if (t === 'constnames') on = state.constnames;
      else if (t === 'border') on = state.showBorder;
      else return;
      btn.classList.toggle('sm-active', !!on);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Product page prefill
  //
  // The product page box sends people here with their place, date (and, for the
  // star map, an optional time) in the link. These are applied to the state BEFORE
  // the first render, so the first sky the customer sees is theirs, not the
  // default one changing into theirs. Then it opens step 2 with a "Your moment"
  // summary. Saved-design links (?resume=) are left alone.
  // ─────────────────────────────────────────────────────────────────────────

  var PREFILL_DEFAULT_TIME = '22:00';

  function readUrlPrefill() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return null; }
    if (params.get('resume')) return null;

    var place = params.get('tsa_place');
    var lat = parseFloat(params.get('tsa_lat'));
    var lon = parseFloat(params.get('tsa_lon'));
    var date = params.get('tsa_date');
    var time = params.get('tsa_time');
    var hasPlace = !!place && !isNaN(lat) && !isNaN(lon) && Math.abs(lat) <= 90 && Math.abs(lon) <= 180;
    var hasDate = /^\d{4}-\d{2}-\d{2}$/.test(date || '');
    var hasTime = true && /^\d{2}:\d{2}$/.test(time || '');
    if (!hasPlace && !hasDate) return null;

    return {
      place: place, lat: lat, lon: lon, hasPlace: hasPlace,
      date: date, hasDate: hasDate,
      time: hasTime ? time : PREFILL_DEFAULT_TIME, hasTime: hasTime
    };
  }

  // Runs inside init(), right after the defaults are set and before anything is drawn.
  function applyUrlPrefill(p) {
    if (!p) return;
    if (p.hasPlace) {
      state.lat = p.lat;
      state.lon = p.lon;
      state.locationName = p.place;
      state.coordinates = formatCoords(p.lat, p.lon);
      state.locationSelected = true;   // satisfies the step 1 check
      var li = $('sm-location');
      if (li) { li.value = p.place; li.classList.add('sm-user-edited'); }
    }

    var dateEl = $('sm-date');
    var timeEl = $('sm-time');
    var ymd = p.hasDate ? p.date : (dateEl && dateEl.value);
    if (p.hasDate && dateEl) { dateEl.value = p.date; dateEl.classList.add('sm-user-edited'); }
    if (timeEl) timeEl.value = p.time;

    if (ymd) {
      var dp = ymd.split('-'), tp = p.time.split(':');
      state.date = new Date(
        parseInt(dp[0], 10), parseInt(dp[1], 10) - 1, parseInt(dp[2], 10),
        parseInt(tp[0], 10) || 0, parseInt(tp[1], 10) || 0
      );
    }
  }

  // Runs once the controls exist: open step 2 and show the "Your moment" summary.
  function showPrefillStep(p) {
    if (!p || !p.hasPlace) return;
    jumpToStep(2);

    var step2 = $('sm-step-2');
    if (step2 && !document.getElementById('tsa-moment-summary')) {
      var dateTxt = state.date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      var line = p.place + ' · ' + dateTxt;
      if (true) {
        line += ' · ' + state.date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) +
                (p.hasTime ? '' : ' (default)');
      }

      var box = document.createElement('div');
      box.id = 'tsa-moment-summary';
      box.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;margin-bottom:16px;border:1px solid #e5e1db;border-radius:8px;background:#faf8f5;font-family:Montserrat,sans-serif;';

      var left = document.createElement('div');
      var label = document.createElement('div');
      label.textContent = 'Your moment';
      label.style.cssText = 'font-size:9.5px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:#C9A96E;margin-bottom:4px;';
      var txt = document.createElement('div');
      txt.textContent = line;
      txt.style.cssText = 'font-size:13px;line-height:1.4;color:#0A1628;';
      left.appendChild(label);
      left.appendChild(txt);

      var edit = document.createElement('button');
      edit.type = 'button';
      edit.textContent = 'Edit';
      edit.style.cssText = 'flex-shrink:0;background:none;border:0;padding:0;font-family:Montserrat,sans-serif;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;text-decoration:underline;color:#0A1628;cursor:pointer;';
      edit.addEventListener('click', function () { jumpToStep(1); });

      box.appendChild(left);
      box.appendChild(edit);
      var host = step2.querySelector('.sm-section') || step2;
      host.insertBefore(box, host.firstChild);
    }

    // Tidy the address bar so a refresh doesn't re-apply the link.
    try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
  }

  function init() {
    var prefill = readUrlPrefill();
    populateDateSelects();
    applyUrlPrefill(prefill);   // before the first render
    updatePosterText();
    updateVariantFromState();

    // Initial poster dimensions
    var poster = $('sm-poster');
    if (poster) {
      if (isMobile()) {
        var initMobileW = Math.min(window.innerWidth - 32, MOBILE_POSTER_MAX_WIDTH);
        poster.style.width = initMobileW + 'px';
        poster.style.height = Math.round(initMobileW * 1.17) + 'px';
        poster.style.transform = 'none';
      } else {
        // Desktop: always render at 24x32 proportions regardless of selected size
        var LOCKED_INIT_RATIO = SIZE_MAP['24" x 32"'].ratio;
        poster.style.height = Math.round(600 * LOCKED_INIT_RATIO) + 'px';
      }

      var mapWrapper = $('sm-map-wrapper');
      // On desktop, use the locked 24x32 map width. On mobile, use the size-specific width.
      if (mapWrapper) {
        mapWrapper.style.width = isMobile() ? (MAP_WIDTHS[state.size] || '78%') : (MAP_WIDTHS['24" x 32"'] || '84%');
      }

      // updateMapScale is the single source of truth for fonts & positioning
      updateMapScale();
    }

    // Load Celestial dependencies in sequence, then render the map
    var celestialUrl = window.starmapCelestialUrl;
    var scripts = [
      'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.17/d3.min.js',
      'https://rawcdn.githack.com/ofrohn/d3-celestial/master/lib/d3.geo.projection.min.js',
      celestialUrl
    ];

    function loadScript(src, cb) {
      if (!src) { cb(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = cb;
      s.onerror = function() {
        console.warn('Failed to load: ' + src);
        cb();
      };
      document.head.appendChild(s);
    }

    function loadSequential(arr, idx) {
      if (idx >= arr.length) { renderMap(); return; }
      loadScript(arr[idx], function() { loadSequential(arr, idx + 1); });
    }

    loadSequential(scripts, 0);

    wireControls();
    showPrefillStep(prefill);
    syncSkyToggles();
    initMobileHandlers();

    // Handle width-only resizes (ignore iOS keyboard-driven height changes)
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      var newWidth = window.innerWidth;
      if (newWidth !== lastWidth) {
        lastWidth = newWidth;
        setTimeout(updateMapScale, 100);
      }
    });

    // Final settling pass once fonts and assets are loaded
    setTimeout(updateMapScale, 1500);

    // Second-item banner. If the customer arrived from the interstitial, show
    // a persistent bar reminding them of the 25% discount they're earning.
    // The discount itself is a native Shopify automatic discount — this bar
    // is signal only, and clears when they navigate away with the item added
    // (see the post-add-to-cart logic in addToCart).
    initSecondItemBanner();
  }

  // Post-buy overlay — a single dark-blue full-screen surface that fades in
  // the moment the customer clicks Buy on the confirm modal, and holds the
  // scene through either:
  //   • add-to-cart → transition its content to the "add another" offer
  //     (first item), or
  //   • add-to-cart → navigate to /cart (second item, overlay persists as
  //     "Adding to your cart" until the page changes).
  //
  // Keeping one surface across both states means the editor never flashes
  // through the transition. The palette matches the confirm modal so the
  // customer's eye stays on the same blue field.

  var postBuyOverlayEl = null;

  function showPostBuyOverlay() {
    if (postBuyOverlayEl) return;
    postBuyOverlayEl = document.createElement('div');
    postBuyOverlayEl.className = 'tsa-pb-overlay';
    postBuyOverlayEl.innerHTML =
      '<div class="tsa-pb-content" data-state="processing">' +
        '<div class="tsa-pb-spinner" aria-hidden="true"></div>' +
        '<p class="tsa-pb-processing-text">Adding to your cart</p>' +
      '</div>';
    document.body.appendChild(postBuyOverlayEl);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      postBuyOverlayEl.classList.add('is-visible');
    });
  }

  function hidePostBuyOverlay() {
    if (!postBuyOverlayEl) return;
    var el = postBuyOverlayEl;
    postBuyOverlayEl = null;
    el.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 350);
  }

  function transitionPostBuyToOffer(cartUrl) {
    if (!postBuyOverlayEl) return;
    var content = postBuyOverlayEl.querySelector('.tsa-pb-content');
    if (!content) return;

    var starmapUrl = (window.STARMAP_CONFIG && window.STARMAP_CONFIG.starmap_url) || '/pages/star-map-customizer';
    var moonUrl    = (window.STARMAP_CONFIG && window.STARMAP_CONFIG.moon_url)    || '/pages/moon-phase-customizer';

    content.classList.add('is-swapping');
    setTimeout(function () {
      var starmapImg = (window.STARMAP_CONFIG && window.STARMAP_CONFIG.starmap_image) ||
        'https://cdn.shopify.com/s/files/1/0921/5387/2720/files/StarFrameTransparent.png?v=1790681291';
      var moonImg = (window.STARMAP_CONFIG && window.STARMAP_CONFIG.moon_image) ||
        'https://cdn.shopify.com/s/files/1/0921/5387/2720/files/MoonFramedTransparent.png?v=1790680972';
        
      content.dataset.state = 'offer';
      content.innerHTML =
        '<span class="tsa-pb-badge">COMPLETE YOUR STORY</span>' +
        '<h2 class="tsa-pb-title">' +
          'Add another design ' +
          '<span class="tsa-pb-title-italic">and save 25%</span>' +
        '</h2>' +
        '<div class="tsa-pb-choices">' +
          '<a class="tsa-pb-choice" href="' + starmapUrl + '" data-choose>' +
            '<span class="tsa-pb-choice-media">' +
              '<img src="' + starmapImg + '" alt="Star map framed print" loading="lazy">' +
            '</span>' +
            '<span class="tsa-pb-choice-title">Star Map</span>' +
            '<span class="tsa-pb-choice-cta">Design now &rarr;</span>' +
          '</a>' +
          '<a class="tsa-pb-choice" href="' + moonUrl + '" data-choose>' +
            '<span class="tsa-pb-choice-media">' +
              '<img src="' + moonImg + '" alt="Moon phase framed print" loading="lazy">' +
            '</span>' +
            '<span class="tsa-pb-choice-title">Moon Phase</span>' +
            '<span class="tsa-pb-choice-cta">Design now &rarr;</span>' +
          '</a>' +
        '</div>' +
        '<a class="tsa-pb-decline" href="' + cartUrl + '?updated=' + Date.now() + '" data-decline>' +
          'No thanks, take me to my cart' +
        '</a>';

      content.querySelectorAll('[data-choose]').forEach(function (a) {
        a.addEventListener('click', function () {
          try { sessionStorage.setItem('tsa_second_item_flow', '1'); } catch (e) {}
        });
      });
      content.querySelectorAll('[data-decline]').forEach(function (a) {
        a.addEventListener('click', function () {
          try { sessionStorage.removeItem('tsa_second_item_flow'); } catch (e) {}
        });
      });

      content.classList.remove('is-swapping');
    }, 250);
  }

  function initSecondItemBanner() {
    var isSecondItem = false;
    try { isSecondItem = sessionStorage.getItem('tsa_second_item_flow') === '1'; }
    catch (e) { return; }
    if (!isSecondItem) return;
    if (document.getElementById('tsa-second-item-banner')) return;

    var bar = document.createElement('div');
    bar.id = 'tsa-second-item-banner';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<span class="tsa-sib-text">25% off applied automatically at checkout</span>';
    document.body.appendChild(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
    initShippingMessage();
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Save for later + Size/Frame guide + Resume
  // Mirror of moon.js block. See that file for architecture notes.
  // ─────────────────────────────────────────────────────────────────────────

  var PRODUCT_KIND = 'starmap';

  // Resume-link loading overlay — see moon.js equivalent for full comment.
  (function injectResumeOverlayEarly() {
    try {
      if (window.location.search.indexOf('resume=') === -1) return;
      if (document.getElementById('tsa-resume-overlay')) return;
      var overlay = document.createElement('div');
      overlay.id = 'tsa-resume-overlay';
      overlay.innerHTML =
        '<div class="tsa-resume-inner">' +
          '<div class="tsa-resume-spinner"></div>' +
          '<p class="tsa-resume-text">Loading your design</p>' +
        '</div>';
      var attach = function () {
        if (document.getElementById('tsa-resume-overlay')) return;
        if (document.body) document.body.appendChild(overlay);
      };
      if (document.body) attach();
      else document.addEventListener('DOMContentLoaded', attach);
    } catch (e) {}
  })();

  function fadeOutResumeOverlay() {
    var overlay = document.getElementById('tsa-resume-overlay');
    if (!overlay) return;
    overlay.classList.add('is-fading');
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 500);
  }

  function serialiseFullState() {
    var s = {};
    Object.keys(state).forEach(function (k) {
      var v = state[k];
      if (v instanceof Date) s[k] = v.toISOString();
      else s[k] = v;
    });
    return s;
  }

  // Capture poster as watermarked JPEG data URL for the email preview.
  // See moon.js equivalent for full architecture notes.
  function capturePosterForEmail() {
    return new Promise(function (resolve) {
      try {
        if (!window.PosterSVG || !window.PosterSVG.renderPosterSVG) return resolve(null);

        // Same logic buildSvgSnapshot uses for the confirm modal: capture the
        // celestial map from the editor as a PNG data URL, then hand it to
        // PosterSVG as the slot image so the actual stars render into the SVG.
        var slotHref = (typeof captureEditorMapSquare === 'function') ? captureEditorMapSquare() : '';
        var noZoom = !!slotHref;
        if (!slotHref) {
          var mapCanvas = document.querySelector('#sm-celestial-map canvas');
          try { slotHref = mapCanvas ? mapCanvas.toDataURL('image/png') : ''; }
          catch (e) { slotHref = ''; }
        }

        var svgMarkup = PosterSVG.renderPosterSVG(state, {
          ratio: posterRatio(),
          border: state.showBorder,
          slotImageHref: slotHref,
          slotNoZoom: noZoom,
          noRing: true
        });
        if (!svgMarkup) return resolve(null);

        var img = new Image();
        var svgBlob = new Blob([svgMarkup], { type: 'image/svg+xml;charset=utf-8' });
        var url = URL.createObjectURL(svgBlob);

        var timeout = setTimeout(function () {
          URL.revokeObjectURL(url);
          resolve(null);
        }, 5000);

        img.onload = function () {
          clearTimeout(timeout);
          try {
            var TARGET_W = 600;
            var ratio = img.height / img.width;
            var canvas = document.createElement('canvas');
            canvas.width = TARGET_W;
            canvas.height = Math.round(TARGET_W * ratio);
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#0a0a0a';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            URL.revokeObjectURL(url);
            resolve(canvas.toDataURL('image/jpeg', 0.82));
          } catch (err) {
            URL.revokeObjectURL(url);
            resolve(null);
          }
        };
        img.onerror = function () {
          clearTimeout(timeout);
          URL.revokeObjectURL(url);
          resolve(null);
        };
        img.src = url;
      } catch (err) {
        resolve(null);
      }
    });
  }

  // Save for later — small centred text link on step 4, above the nav row.
  function injectStep4SaveLink() {
    var step4 = $('sm-step-4');
    if (!step4) return;
    if (step4.querySelector('[data-tsa-step4-save]')) return;
    var nav = step4.querySelector('.sm-step-nav');
    if (!nav) return;

    var wrap = document.createElement('div');
    wrap.setAttribute('data-tsa-step4-save', '');
    wrap.className = 'tsa-save-link-wrap';
    wrap.innerHTML = '<button type="button" class="tsa-save-link">Not ready? Save this design for later</button>';

    nav.parentNode.insertBefore(wrap, nav);
    wrap.querySelector('button').addEventListener('click', showSaveModal);
  }

  // Size guide — button injected right-aligned inside the "SIZE" label.
  function injectSizeGuideButton() {
    injectGuideLink('.sm-size-row', 'size', 'See size guide');
  }

  // Frame guide — same pattern, injected into the "FRAME COLOR" label.
  function injectFrameGuideButton() {
    var frameField = $('sm-frame-colour-field');
    if (!frameField) return;
    var swatchRow = frameField.querySelector('.sm-swatch-row');
    if (swatchRow) injectGuideLink(swatchRow, 'frame', 'See frame guide');
  }

  function injectGuideLink(rowEl, kind, label) {
    var row = typeof rowEl === 'string' ? document.querySelector(rowEl) : rowEl;
    if (!row) return;
    var field = row.closest('.sm-field');
    if (!field) return;
    var labelEl = field.querySelector(':scope > label');
    if (!labelEl) return;
    if (labelEl.querySelector('[data-tsa-guide]')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tsa-guide-link';
    btn.setAttribute('data-tsa-guide', kind);
    btn.innerHTML = label;
    btn.addEventListener('click', function () { showGuideModal(kind); });

    labelEl.classList.add('sm-label-with-guide');
    labelEl.appendChild(btn);
  }

  // Preload guide images at browser-idle time with low fetch priority so it
  // never competes with step-1 location typing.
  var guideImagesPreloaded = false;
  function preloadGuideImages() {
    if (guideImagesPreloaded) return;
    guideImagesPreloaded = true;
    var cfg = window.STARMAP_CONFIG || {};
    ['size_guide_poster_url', 'size_guide_canvas_url', 'frame_guide_wooden_url', 'frame_guide_canvas_url'].forEach(function (k) {
      if (!cfg[k]) return;
      var img = new Image();
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.src = cfg[k];
    });
  }

  function armGuidePreload() {
    var kick = function () { preloadGuideImages(); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(kick, { timeout: 5000 });
    } else {
      setTimeout(kick, 3000);
    }
  }

  function showGuideModal(kind) {
    var cfg = window.STARMAP_CONFIG || {};
    var isCanvas = isCanvasFormat(state.format);
    var url;

    if (kind === 'frame') {
      url = isCanvas ? cfg.frame_guide_canvas_url : cfg.frame_guide_wooden_url;
    } else {
      url = isCanvas ? cfg.size_guide_canvas_url : cfg.size_guide_poster_url;
    }

    if (!url) {
      alert('Guide is not available yet.');
      return;
    }

    var overlay = document.createElement('div');
    overlay.className = 'tsa-guide-overlay';
    overlay.innerHTML =
      '<button type="button" class="tsa-guide-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
      '<img class="tsa-guide-img" src="' + url + '" alt="Guide">';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var close = function () {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        document.body.style.overflow = '';
      }, 250);
    };
    overlay.querySelector('.tsa-guide-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }

  function showSaveModal() {
    var overlay = document.createElement('div');
    overlay.className = 'tsa-save-overlay';
    overlay.innerHTML =
      '<div class="tsa-save-box" role="dialog" aria-label="Save for later">' +
        '<button type="button" class="tsa-save-close" aria-label="Close">&times;</button>' +
        '<div class="tsa-save-body" data-state="form">' +
          '<h3 class="tsa-save-title">Save this design for later</h3>' +
          '<p class="tsa-save-sub">Enter your email and we\'ll send you a link so you can come back to this design whenever you\'re ready.</p>' +
          '<label class="tsa-save-label">Email address</label>' +
          '<input type="email" inputmode="email" autocomplete="email" class="tsa-save-input" placeholder="you@email.com" data-save-email>' +
          '<label class="tsa-save-check">' +
            '<input type="checkbox" data-save-consent>' +
            '<span>I agree to receive marketing emails from The Stars Above. <strong>(required)</strong></span>' +
          '</label>' +
          '<p class="tsa-save-err" data-save-err hidden></p>' +
          '<button type="button" class="tsa-save-submit" data-save-submit>Send me the link</button>' +
          '<p class="tsa-save-note">Your link expires in 3 days.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var close = function () {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        document.body.style.overflow = '';
      }, 250);
    };
    overlay.querySelector('.tsa-save-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    var submitBtn = overlay.querySelector('[data-save-submit]');
    submitBtn.addEventListener('click', function () {
      var emailEl = overlay.querySelector('[data-save-email]');
      var consentEl = overlay.querySelector('[data-save-consent]');
      var errEl = overlay.querySelector('[data-save-err]');
      var email = (emailEl.value || '').trim();
      var showErr = function (m) { errEl.textContent = m; errEl.hidden = !m; };

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return showErr('Please enter a valid email address.');
      if (!consentEl.checked) return showErr('Please tick the box to agree to marketing emails.');
      showErr('');

      submitBtn.disabled = true;
      var orig = submitBtn.textContent;
      submitBtn.textContent = 'Sending…';

      capturePosterForEmail().then(function (previewData) {
        return fetch(WORKER_URL + '/api/save', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            consent: true,
            product: PRODUCT_KIND,
            state: serialiseFullState(),
            previewData: previewData,
            heading: state.name || ''
          })
        });
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (b) { throw new Error(b.error || 'Save failed'); });
          return r.json();
        })
        .then(function () {
          var body = overlay.querySelector('.tsa-save-body');
          body.dataset.state = 'done';
          body.innerHTML =
            '<div class="tsa-save-tick" aria-hidden="true">' +
              '<svg viewBox="0 0 44 44" width="44" height="44">' +
                '<circle cx="22" cy="22" r="21" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.35"/>' +
                '<path d="M13 22.5l6 6 12-13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</div>' +
            '<h3 class="tsa-save-title">Your design is saved</h3>' +
            '<p class="tsa-save-sub">We\'ve emailed you a link. If it hasn\'t arrived in a few minutes, please check your spam folder.</p>' +
            '<button type="button" class="tsa-save-submit" data-save-done>Back to my design</button>';
          body.querySelector('[data-save-done]').addEventListener('click', close);
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = orig;
          showErr(err.message || 'Something went wrong. Please try again.');
        });
    });

    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }

  function tryResumeSavedDesign() {
    var params = new URLSearchParams(window.location.search);
    var token = params.get('resume');
    if (!token || !/^[0-9a-f]{32}$/.test(token)) {
      fadeOutResumeOverlay();
      return;
    }

    fetch(WORKER_URL + '/api/save/' + token)
      .then(function (r) {
        if (!r.ok) return r.json().then(function (b) { throw new Error(b.error || 'Not found'); });
        return r.json();
      })
      .then(function (data) {
        if (!data.saved || !data.saved.state) throw new Error('Invalid saved data');
        restoreSavedDesign(data.saved.state);
        jumpToStep(4);
        // Celestial map takes ~1s to redraw after location change, so give it
        // a little longer than the moon before revealing.
        setTimeout(fadeOutResumeOverlay, 900);
      })
      .catch(function (err) {
        console.warn('Resume failed:', err && err.message);
        fadeOutResumeOverlay();
      });
  }

  function restoreSavedDesign(saved) {
    Object.keys(saved).forEach(function (k) {
      var v = saved[k];
      if (k === 'date' && typeof v === 'string') state.date = new Date(v);
      else state[k] = v;
    });

    var setInput = function (id, val) {
      var el = $(id);
      if (el && val != null) el.value = val;
    };
    setInput('sm-name-input', state.name);
    setInput('sm-message-input', state.message);
    setInput('sm-location', state.locationName);

    // Show the font rows for any restored text, with the saved fonts highlighted.
    syncFontButtons();
    syncFontFields();

    if (state.date instanceof Date && !isNaN(state.date)) {
      var d = state.date;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var dateEl = $('sm-date');
      var timeEl = $('sm-time');
      if (dateEl) dateEl.value = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
      if (timeEl) timeEl.value = pad(d.getHours()) + ':' + pad(d.getMinutes());
    }

    // Redraw the sky at the restored location/date and rescale the map.
    if (typeof renderMap === 'function') renderMap();
    if (typeof updateMapScale === 'function') updateMapScale();
  }

  // Mirror of the wizard's own goToStep — see moon.js for full comment.
  function jumpToStep(n) {
    document.querySelectorAll('.sm-step-panel').forEach(function (p) {
      p.classList.add('sm-step-hidden');
    });
    document.querySelectorAll('.sm-step-item').forEach(function (item) {
      var s = parseInt(item.dataset.step, 10);
      item.classList.remove('sm-step-active', 'sm-step-done');
      if (s === n) item.classList.add('sm-step-active');
      if (s < n) item.classList.add('sm-step-done');
    });
    var panel = $('sm-step-' + n);
    if (panel) panel.classList.remove('sm-step-hidden');
    var controls = document.querySelector('.sm-controls');
    if (controls) controls.scrollTop = 0;
  }

  function showResumedToast() {
    var toast = document.createElement('div');
    toast.className = 'tsa-resumed-toast';
    toast.innerHTML =
      '<span class="tsa-resumed-tick" aria-hidden="true">' +
        '<svg viewBox="0 0 22 22" width="16" height="16">' +
          '<path d="M6 11.5l3 3 7-7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<span>Saved design loaded</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }, 4000);
  }

  setTimeout(function () {
    injectStep4SaveLink();
    injectSizeGuideButton();
    injectFrameGuideButton();
    armGuidePreload();
    tryResumeSavedDesign();
  }, 0);

  // Expose minimal public API for debugging
  window.StarmapEngine = { state: state, renderMap: renderMap, updateMapScale: updateMapScale, uploadToWorker: uploadToWorker };
})();


/* ── Star-text PREVIEW watermark (star map editor only) ── */
(function () {
  var WORD = 'PREVIEW';
  var WIDTH = 0.8;       // how much of the sky the word spans (0.8 = 80%)
  var HEIGHT = 0.46;     // how far down the sky the word sits (0.5 = middle)
  var COUNT = 650;       // how many stars make up the word
  var OPACITY = 0.8;     // overall strength of the watermark
  var cache = null;

  function seeded(seed) {
    return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
  }

  // Star positions, worked out once on a 400px grid and stored as fractions,
  // so they can be drawn at any size (editor, enlarge, confirm). Stars are
  // scattered at random inside the letters (not on a grid), with a minimum gap,
  // so the word reads like part of the sky rather than a stamp.
  function getStars() {
    if (cache) return cache;
    var M = 400;
    var mask = document.createElement('canvas');
    mask.width = M; mask.height = M;
    var mc = mask.getContext('2d');
    var font = '"Helvetica Neue", Helvetica, Arial, sans-serif';
        mc.font = '800 100px ' + font;
    var size = 100 * (M * WIDTH) / mc.measureText(WORD).width;
    mc.font = '800 ' + size + 'px ' + font;
    mc.textAlign = 'center';
    mc.textBaseline = 'middle';
    mc.fillText(WORD, M / 2, M * HEIGHT);
    var px = mc.getImageData(0, 0, M, M).data;

    var rand = seeded(20261007);
    var list = [];
    var gap = 2.1;                 // minimum distance between stars (in 400px units)
    for (var tries = 0; tries < 20000 && list.length < COUNT; tries++) {
      var x = rand() * M, y = rand() * M;
      var ix = x | 0, iy = y | 0;
      if (px[(iy * M + ix) * 4 + 3] < 128) continue;
      var clash = false;
      for (var j = list.length - 1; j >= 0 && j > list.length - 60; j--) {
        var dx = list[j].px - x, dy = list[j].py - y;
        if (dx * dx + dy * dy < gap * gap) { clash = true; break; }
      }
      if (clash) continue;
      var s = rand();
      var big = s > 0.95;
      var r = big ? 1.4 + rand() * 0.9 : (s > 0.8 ? 0.95 + rand() * 0.35 : 0.45 + rand() * 0.45);
      list.push({ px: x, py: y, x: x / M, y: y / M, r: r / M, a: 0.8 + rand() * 0.2, big: big, d: rand() });
    }
    cache = list;
    return list;
  }

  // Draw the stars. t = milliseconds into the twinkle-in (omit for fully shown).
  function paint(ctx, w, light, t) {
    var rgb = light ? '15,25,45' : '255,255,255';
    var stars = getStars();
    for (var i = 0; i < stars.length; i++) {
      var st = stars[i];
      var k = 1;
      if (typeof t === 'number') {
        k = (t - st.d * 800) / 400;
        if (k <= 0) continue;
        if (k > 1) k = 1;
        k = k * k * (3 - 2 * k);
      }
      var x = st.x * w, y = st.y * w, r = st.r * w;
      if (st.big) {
        var g = ctx.createRadialGradient(x, y, 0, x, y, r * 2.6);
        g.addColorStop(0, 'rgba(' + rgb + ',' + (0.3 * k).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(' + rgb + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(x, y, r * 2.6, 0, Math.PI * 2); ctx.fill();
      }
      ctx.fillStyle = 'rgba(' + rgb + ',' + (st.a * k).toFixed(3) + ')';
      ctx.beginPath(); ctx.arc(x, y, r * (0.6 + 0.4 * k), 0, Math.PI * 2); ctx.fill();
    }
  }

  // Used by the enlarge and confirm previews to stamp the stars into their image.
  window.TSAStarWM = {
    stamp: function (ctx, w, light) {
      ctx.save();
      ctx.globalAlpha = OPACITY;
      paint(ctx, w, light);
      ctx.restore();
    }
  };

  function init() {
    var wrap = document.getElementById('sm-map-wrapper');
    if (!wrap || !document.getElementById('sm-celestial-map')) return;
    if (wrap.querySelector('.tsa-star-wm')) return;

    var poster = wrap.closest('.sm-poster');
    var cv = document.createElement('canvas');
    cv.className = 'tsa-star-wm';
    cv.setAttribute('aria-hidden', 'true');
    cv.style.transition = 'opacity 0.3s ease';
    cv.style.opacity = '0';
    wrap.appendChild(cv);
    wrap.classList.add('tsa-wm-on');
    var ctx = cv.getContext('2d');

    var w = 0, dpr = 1, visible = false, animStart = 0, raf = 0;

    function isLight() { return !!(poster && poster.getAttribute('data-theme') === 'light'); }

    function render(t) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, w);
      paint(ctx, w, isLight(), t);
    }

    function resize() {
      w = wrap.clientWidth;
      if (!w) return;
      dpr = Math.min(window.devicePixelRatio || 1, 3);
      cv.width = Math.round(w * dpr);
      cv.height = Math.round(w * dpr);
      render(visible ? performance.now() - animStart : 0);
    }

    function reveal() {
      visible = true;
      animStart = performance.now();
      render(0);
      cv.style.opacity = String(OPACITY);
      cancelAnimationFrame(raf);
      (function frame() {
        var t = performance.now() - animStart;
        render(t);
        if (t < 1300) raf = requestAnimationFrame(frame);
      })();
    }

    function hide() {
      visible = false;
      cancelAnimationFrame(raf);
      cv.style.opacity = '0';
    }

    // Watch the sky canvas. Several redraws close together means it is
    // spinning or moving, so the word steps aside and twinkles back once still.
    var draws = [], hiddenAt = performance.now(), watchedAt = 0;
    function note() {
      var now = performance.now();
      if (!draws.length || now - draws[draws.length - 1] > 12) draws.push(now);
    }
    function watchSky() {
      var c = document.querySelector('#sm-celestial-map canvas');
      if (!c || c.__tsaWatched) return;
      var c2 = c.getContext('2d');
      if (!c2) return;
      ['clearRect', 'fillRect'].forEach(function (fn) {
        var orig = c2[fn];
        c2[fn] = function () { note(); return orig.apply(this, arguments); };
      });
      c.__tsaWatched = true;
      watchedAt = performance.now();
    }

    setInterval(function () {
      watchSky();
      var now = performance.now();
      while (draws.length && now - draws[0] > 400) draws.shift();
      var moving = draws.length >= 3;
      var settled = !draws.length || now - draws[draws.length - 1] > 350;
      var ready = (!poster || poster.classList.contains('sm-poster-ready')) && watchedAt && now - watchedAt > 400;

      if (moving && visible) { hide(); hiddenAt = now; }
      else if (!visible && ((ready && settled) || now - hiddenAt > 6000)) reveal();
    }, 120);

    if (window.ResizeObserver) new ResizeObserver(resize).observe(wrap);
    else window.addEventListener('resize', resize);
    if (poster && window.MutationObserver) {
      new MutationObserver(function () { render(visible ? performance.now() - animStart : 0); })
        .observe(poster, { attributes: true, attributeFilter: ['data-theme'] });
    }
    resize();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();